window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $("[data-section-id]", evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = _.filter(this.instances, function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $("[data-section-type=" + type + "]").each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = "js-focus-hidden";

    $element
      .first()
      .attr("tabIndex", "-1")
      .focus()
      .addClass(focusClass)
      .one("blur", callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr("tabindex");
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $("a[href*=#]").on(
      "click",
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr("tabindex", "-1");
    options.$elementToFocus.focus();

    $(document).off("focusin");

    $(document).on(eventName, function (evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (options.$container && options.$container.length) {
      options.$container.removeAttr("tabindex");
    }

    $(document).off(eventName);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === "string") {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function () {
  var moneyFormat = "${{amount}}"; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      "change",
      this._onSelectChange.bind(this)
    );
    $(window).on(
      "load",
      this._onPageLoad.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.attr("type");
          var currentOption = {};

          if (type === "radio" || type === "checkbox") {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data("index");

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function (variant) {
        return selectedValues.every(function (values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    _onPageLoad: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: "variantPageLoad",
        variant: variant
      });
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: "variantChange",
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }

      // BEGIN SWATCHES
      if (variant) {
        var form = jQuery("#" + this.selector).closest("form");
        for (var i = 0, length = variant.options.length; i < length; i++) {
          var radioButton = form.find(
            '.swatch[data-option-index="' +
            i +
            '"] :radio[value="' +
            variant.options[i] +
            '"]'
          );
          if (radioButton.size()) {
            radioButton.get(0).checked = true;
          }
        }

        //         jQuery('.swatch .header span').text(variant.title);
      }
      // END SWATCHES

      if (variant) {
        $(".product-form_item-submit").attr("data-vpid", variant.id);

        if ($(".product-detail-tabs-content__item--features").length) {
          $(".product-detail-tabs-content__item--features > div").hide();
          $(
            '.product-detail-tabs-content__item--features > div[data-var="' +
            variant.id +
            '"]'
          ).show();
        }
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantImageChange",
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function (variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: "variantSKUChange",
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id;
      window.history.replaceState({ path: newurl }, "", newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
      $("#ProductSelectSticky-product-template").val(variant.id);
    }
  });

  return Variants;
})();

/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function () {
  function Drawer(id, position, options) {
    var defaults = {
      close: ".js-drawer-close",
      open: ".js-drawer-open-" + position,
      openClass: "js-drawer-open",
      dirOpenClass: "js-drawer-open-" + position
    };

    this.nodes = {
      $parent: $("html").add("body"),
      $page: $("#PageContainer")
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $("#" + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function () {
    $(this.config.open).on("click", $.proxy(this.open, this));
    this.$drawer.on("click", this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + " " + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: "drawer_focus"
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === "function"
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
      this.$activeSource.attr("aria-expanded", "true");
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger("blur");

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + " " + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: "drawer_focus"
    });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function () {
    this.nodes.$parent.on(
      "keyup.drawer",
      $.proxy(function (evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on("touchmove.drawer", function () {
      return false;
    });

    this.nodes.$page.on(
      "click.drawer",
      $.proxy(function () {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function () {
    this.nodes.$page.off(".drawer");
    this.nodes.$parent.off(".drawer");
  };

  return Drawer;
})();

/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function () {
  var selectors = {
    body: "body",
    navigation: "#AccessibleNav",
    siteNavHasDropdown: ".site-nav--has-dropdown",
    siteNavChildLinks: ".site-nav__child-link",
    siteNavActiveDropdown: ".site-nav--active-dropdown",
    siteNavLinkMain: ".site-nav__link--main",
    siteNavChildLink: ".site-nav__link--last"
  };

  var config = {
    activeClass: "site-nav--active-dropdown",
    childLinkClass: "site-nav__child-link"
  };

  var cache = {};

  function init() {
    cacheSelectors();

    cache.$parents.on("click.siteNav", function (evt) {
      var $el = $(this);

      if (!$el.hasClass(config.activeClass)) {
        // force stop the click from happening
        evt.preventDefault();
        evt.stopImmediatePropagation();
        showDropdown($el);
      }
    });

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on("focusout.siteNav", function () {
      setTimeout(function () {
        if (
          $(document.activeElement).hasClass(config.childLinkClass) ||
          !cache.$activeDropdown.length
        ) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on("focus.siteNav", function () {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on("click.siteNav", function (evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });
  }

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown)
    };
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass);

    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    cache.$activeDropdown = $el;

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr("aria-expanded", "true");

    setTimeout(function () {
      $(window).on("keyup.siteNav", function (evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      $(selectors.body).on("click.siteNav", function () {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr("aria-expanded", "false");
    $el.removeClass(config.activeClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off("click.siteNav");
    $(window).off("keyup.siteNav");
  }

  function unload() {
    $(window).off(".siteNav");
    cache.$parents.off(".siteNav");
    cache.$subMenuLinks.off(".siteNav");
    cache.$topLevel.off(".siteNav");
    $(selectors.siteNavChildLink).off(".siteNav");
    $(selectors.body).off(".siteNav");
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function () {
  var classes = {
    mobileNavOpenIcon: "mobile-nav--open",
    mobileNavCloseIcon: "mobile-nav--close",
    navLinkWrapper: "mobile-nav__item",
    navLink: "mobile-nav__link",
    subNavLink: "mobile-nav__sublist-link",
    return: "mobile-nav__return-btn",
    subNavActive: "is-active",
    subNavClosing: "is-closing",
    navOpen: "js-menu--is-open",
    subNavShowing: "sub-nav--is-open",
    thirdNavShowing: "third-nav--is-open",
    subNavToggleBtn: "js-toggle-submenu"
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQuerySmall = "screen and (max-width: 749px)";

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on("mousedown", toggleMobileNav);
    cache.$subNavToggleBtn.on("click.subNav", toggleSubNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function () {
        closeMobileNav();
      }
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $("#PageContainer"),
      $siteHeader: $(".site-header"),
      $mobileNavToggle: $(".js-mobile-nav-toggle"),
      $mobileNavContainer: $(".mobile-nav-wrapper"),
      $mobileNav: $("#MobileNav"),
      $sectionHeader: $("#shopify-section-header"),
      $subNavToggleBtn: $("." + classes.subNavToggleBtn)
    };
  }

  function openMobileNav() {
    var translateHeaderHeight =
      cache.$siteHeader.outerHeight() + cache.$siteHeader.position().top;

    cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: "translateY(" + translateHeaderHeight + "px)"
    });

    cache.$pageContainer.css({
      transform:
        "translate3d(0, " + cache.$mobileNavContainer[0].scrollHeight + "px, 0)"
    });

    slate.a11y.trapFocus({
      $container: cache.$sectionHeader,
      $elementToFocus: cache.$mobileNav
        .find("." + classes.navLinkWrapper + ":first")
        .find("." + classes.navLink),
      namespace: "navFocus"
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon);

    // close on escape
    $(window).on("keyup.mobileNav", function (evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: "translateY(-100%)"
    });

    cache.$pageContainer.removeAttr("style");

    slate.a11y.trapFocus({
      $container: $("html"),
      $elementToFocus: $("body")
    });

    cache.$mobileNavContainer.one(
      "TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle",
      function () {
        slate.a11y.removeTrapFocus({
          $container: cache.$mobileNav,
          namespace: "navFocus"
        });
        document.activeElement.blur();
      }
    );

    cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon);

    $(window).off("keyup.mobileNav");

    scrollTo(0, 0);
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }

    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;

    if (isReturn) {
      // Close all subnavs by removing active class on buttons
      $(
        "." + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
      ).removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;

    goToSubnav($toggleBtn.data("target"));
  }

  function goToSubnav(target) {
    /*eslint-disable shopify/jquery-dollar-sign-reference */

    var $targetMenu = target
      ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
      : cache.$mobileNav;

    menuLevel = $targetMenu.data("level") ? $targetMenu.data("level") : 1;

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav.prepareTransition().addClass(classes.subNavClosing);
    }

    $activeSubNav = $targetMenu;

    var $elementToFocus = target
      ? $targetMenu.find("." + classes.subNavLink + ":first")
      : $activeTrigger;

    /*eslint-enable shopify/jquery-dollar-sign-reference */

    var translateMenuHeight = $targetMenu.outerHeight();

    var openNavClass =
      menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

    cache.$mobileNavContainer
      .css("height", translateMenuHeight)
      .removeClass(classes.thirdNavShowing)
      .addClass(openNavClass);

    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing)
        .removeClass(classes.subNavShowing);
    }

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one(
      "TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle",
      function () {
        slate.a11y.trapFocus({
          $container: $targetMenu,
          $elementToFocus: $elementToFocus,
          namespace: "subNavFocus"
        });

        cache.$mobileNavContainer.off(".subnavToggle");
        isTransitioning = false;
      }
    );

    // Match height of subnav
    cache.$pageContainer.css({
      transform: "translateY(" + translateMenuHeight + "px)"
    });

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav
  };
})(jQuery);

window.theme = window.theme || {};

theme.Search = (function () {
  var selectors = {
    search: ".search",
    searchSubmit: ".search__submit",
    searchInput: ".search__input",

    siteHeader: ".site-header",
    siteHeaderSearchToggle: ".site-header__search-toggle",
    siteHeaderSearch: ".site-header__search",

    searchDrawer: ".search-bar",
    searchDrawerInput: ".search-bar__input",

    searchHeader: ".search-header",
    searchHeaderInput: ".search-header__input",
    searchHeaderSubmit: ".search-header__submit",

    mobileNavWrapper: ".mobile-nav-wrapper"
  };

  var classes = {
    focus: "search--focus",
    mobileNavIsOpen: "js-menu--is-open"
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    initDrawer();
    searchSubmit();

    $(selectors.searchHeaderInput)
      .add(selectors.searchHeaderSubmit)
      .on("focus blur", function () {
        $(selectors.searchHeader).toggleClass(classes.focus);
      });

    $(selectors.siteHeaderSearchToggle).on("click", function () {
      var searchHeight = $(selectors.siteHeader).outerHeight();
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

      $(selectors.searchDrawer).css({
        height: searchHeight + "px",
        top: searchOffset + "px"
      });
    });
  }

  function initDrawer() {
    // Add required classes to HTML
    $("#PageContainer").addClass("drawer-page-content");
    $(".js-drawer-open-top")
      .attr("aria-controls", "SearchDrawer")
      .attr("aria-expanded", "false");

    theme.SearchDrawer = new theme.Drawers("SearchDrawer", "top", {
      onDrawerOpen: searchDrawerFocus
    });
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));

    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      theme.MobileNav.closeMobileNav();
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchSubmit() {
    $(selectors.searchSubmit).on("click", function (evt) {
      var $el = $(evt.target);
      var $input = $el.parents(selectors.search).find(selectors.searchInput);
      if ($input.val().length === 0) {
        evt.preventDefault();
        searchFocus($input);
      }
    });
  }

  return {
    init: init
  };
})();

(function () {
  var selectors = {
    backButton: ".return-link"
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one("click", function (evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement("a");
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function () {
  this.$slideshow = null;
  var classes = {
    wrapper: "slideshow-wrapper",
    slideshow: "slideshow",
    currentSlide: "slick-current",
    video: "slideshow__video",
    videoBackground: "slideshow__video--background",
    closeVideoBtn: "slideshow__video-control--close",
    pauseButton: "slideshow__pause",
    isPaused: "is-paused"
  };

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest("." + classes.wrapper);
    this.$pause = this.$wrapper.find("." + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: false,
      dots: true,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data("autoplay"),
      autoplaySpeed: this.$slideshow.data("speed")
    };

    this.$slideshow.on("beforeChange", beforeChange.bind(this));
    this.$slideshow.on("init", slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    this.$pause.on("click", this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr("aria-live");

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on("focusin", function (evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr("aria-live", "polite");

      if (autoplay) {
        $slider.slick("slickPause");
      }
    });

    // Resume autoplay
    $wrapper.on("focusout", function (evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr("aria-live");

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick("slickPlay");
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on("keydown", function (evt) {
        if (evt.which === 37) {
          $slider.slick("slickPrev");
        }

        if (evt.which === 39) {
          $slider.slick("slickNext");
        }

        // Update focus on newly selected tab
        if (evt.which === 37 || evt.which === 39) {
          obj.$dots.find(".slick-active button").focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find("." + classes.currentSlide);
    var $nextSlide = $slider.find(
      '.slideshow__slide[data-slick-index="' + nextSlide + '"]'
    );

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find("." + classes.video);
      var currentVideoId = $currentVideo.attr("id");
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr("tabindex", "-1");
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find("." + classes.video);
      var videoId = $video.attr("id");
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr("tabindex", "0");
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find("." + classes.video).length;
  }

  slideshow.prototype.togglePause = function () {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick("slickPlay");
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick("slickPause");
    }
  };

  function getSlideshowId($el) {
    return "#Slideshow-" + $el.data("id");
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function () {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: "opaque",
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: "video-is-playing",
    paused: "video-is-paused",
    loading: "video-is-loading",
    loaded: "video-is-loaded",
    slideshowWrapper: "slideshow-wrapper",
    slide: "slideshow__slide",
    slideBackgroundVideo: "slideshow__slide--background-video",
    slideDots: "slick-dots",
    videoChrome: "slideshow__video--chrome",
    videoBackground: "slideshow__video--background",
    playVideoBtn: "slideshow__video-control--play",
    closeVideoBtn: "slideshow__video-control--close",
    currentSlide: "slick-current",
    slickClone: "slick-cloned",
    supportsAutoplay: "autoplay",
    supportsNoAutoplay: "no-autoplay"
  };

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr("id")] = {
      id: $video.attr("id"),
      videoId: $video.data("id"),
      type: $video.data("type"),
      status: $video.data("type") === "chrome" ? "closed" : "background", // closed, open, background
      videoSelector: $video.attr("id"),
      $parentSlide: $video.closest("." + classes.slide),
      $parentSlideshowWrapper: $video.closest("." + classes.slideshowWrapper),
      controls: $video.data("type") === "background" ? 0 : 1,
      slideshow: $video.data("slideshow")
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === "function") {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === "function"
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function () {
        setAutoplaySupport(true);
      })
      .fail(function () {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function () {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function () {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function () {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (window.mobileCheck()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality("hd1080");
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $("#" + videoData.id).attr("tabindex", "-1");

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case "background-chrome":
      case "background":
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case "background":
        videoPlayers[videoData.id].seekTo(0);
        break;
      case "background-chrome":
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case "chrome":
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === "background") {
      return;
    }

    $("#" + videoData.id).attr("tabindex", "0");

    switch (videoData.type) {
      case "chrome":
      case "background-chrome":
        $slideshow.removeClass(classes.paused).addClass(classes.playing);
        $slide.removeClass(classes.paused).addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find("." + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === "background-chrome") {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== "closed" && videoData.type !== "background") {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === "chrome" && videoData.status === "closed") {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(" ");

    $("#" + videoData.id).attr("tabindex", "-1");

    videoData.status = "closed";

    switch (videoData.type) {
      case "background-chrome":
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case "chrome":
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = "open";

    switch (videoData.type) {
      case "background-chrome":
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case "chrome":
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on("keydown.videoPlayer", function (evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $("." + classes.videoBackground).each(function (index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest("." + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player
        .width(playerWidth)
        .height(playerHeight)
        .css({
          left: (slideWidth - playerWidth) / 2,
          top: 0
        }); // player width is greater, offset left; reset top
    } else {
      // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player
        .width(slideWidth)
        .height(playerHeight)
        .css({
          left: 0,
          top: (playerHeight - playerHeight) / 2
        }); // player height is greater, offset top; reset left
    }

    $player.prepareTransition().addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $("#" + playerId)
      .removeAttr("style")
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = "open";
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $("#" + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo);

    videos[playerId].status = "background";
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on("click.videoPlayer", "." + classes.playVideoBtn, function (
      evt
    ) {
      var playerId = $(evt.currentTarget).data("controls");
      startVideoOnClick(playerId);
    });

    $(document).on("click.videoPlayer", "." + classes.closeVideoBtn, function (
      evt
    ) {
      var playerId = $(evt.currentTarget).data("controls");
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      "resize.videoPlayer",
      $.debounce(250, function () {
        if (youtubeLoaded) {
          sizeBackgroundVideos();
        }
      })
    );
  }

  function removeEvents() {
    $(document).off(".videoPlayer");
    $(window).off(".videoPlayer");
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();

/* ================ TEMPLATES ================ */
(function () {
  var $filterBy = $("#BlogTagFilter");

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on("change", function () {
    location.href = $(this).val();
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function () {
  function initEventListeners() {
    // Show reset password form
    $("#RecoverPassword").on("click", function (evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $("#HideRecoverPasswordLink").on("click", function (evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $("#RecoverPasswordForm").css("display", "none");
    //  $('#RecoverPasswordForm').toggleClass('hide');
    $("#customer_login").css("display", "block");
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $(".reset-password-success");

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $("#ResetSuccess").removeClass("hide");
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $("#AddressNewForm");

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        "AddressCountryNew",
        "AddressProvinceNew",
        {
          hideElement: "AddressProvinceContainerNew"
        }
      );
    }

    // Initialize each edit form's country/province selector
    $(".address-country-option").each(function () {
      var formId = $(this).data("form-id");
      var countrySelector = "AddressCountry_" + formId;
      var provinceSelector = "AddressProvince_" + formId;
      var containerSelector = "AddressProvinceContainer_" + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $(".address-new-toggle").on("click", function () {
      $newAddressForm.toggleClass("hide");
    });

    $(".address-edit-toggle").on("click", function () {
      var formId = $(this).data("form-id");
      $("#EditAddress_" + formId).toggleClass("hide");
    });

    $(".address-delete").on("click", function () {
      var $el = $(this);
      var formId = $el.data("form-id");
      var confirmMessage = $el.data("confirm-message");

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || "Are you sure you wish to delete this address?"
        )
      ) {
        Shopify.postLink("/account/addresses/" + formId, {
          parameters: { _method: "delete" }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function () {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();

/*!
 * jQuery ClassyScroll
 * http://www.class.pm/projects/jquery/classyscroll
 *
 * Copyright 2011 - 2013, Class.PM www.class.pm
 * Written by Marius Stanciu - Sergiu <marius@picozu.net>
 * Licensed under the GPL Version 3 license.
 * Version 1.1.0
 *
 */

(function ($) {
  function _ClassyScroll(c, s) {
    this.container = $(c);
    this.settings = s;
    this.timer = 0;
    this.before = {
      v: 0,
      h: 0
    };
    this.touch = {};
    this.pressed = 0;
    this.vslider = $("<div/>", {
      class: "scrollbar-handle"
    });
    this.vpath = $("<div/>", {
      class: "scrollbar-path-vertical"
    });
    this.hslider = $("<div/>", {
      class: "scrollbar-handle"
    });
    this.hpath = $("<div/>", {
      class: "scrollbar-path-horizontal"
    });
    this.sliders = this.vslider.add(this.hslider);
    this.container
      .css({
        overflow: "hidden",
        position: "relative"
      })
      .contents()
      .filter(this.settings.contentFilter)
      .wrapAll('<div class="scrollbar-content"></div>');
    this.content = this.container.children(".scrollbar-content").css({
      top: 0,
      left: 0,
      position: "relative",
      float: "left"
    });
    if (this.settings.scroll == "horizontal") {
      this.container.prepend(this.hpath.append(this.hslider));
    } else if (this.settings.scroll == "vertical") {
      this.container.prepend(this.vpath.append(this.vslider));
    } else {
      this.container.prepend(
        this.vpath.append(this.vslider),
        this.hpath.append(this.hslider)
      );
    }
    this.vpath.add(this.hpath).css({
      "z-index": this.settings.zIndex,
      display: "none"
    });
    this.vslider.css({
      height: this.settings.sliderSize,
      opacity: this.settings.sliderOpacity
    });
    this.hslider.css({
      width: this.settings.sliderSize,
      opacity: this.settings.sliderOpacity
    });
    if (this.settings.sliderOpacity) {
      this.sliders.hover(
        this.fixFn(function () {
          this.sliders.stop().fadeTo(this.settings.sliderOpacityTime, 1);
        }),
        this.fixFn(function () {
          if (!this.pressed) {
            this.sliders
              .stop()
              .fadeTo(
                this.settings.sliderOpacityTime,
                this.settings.sliderOpacity
              );
          }
        })
      );
    }
    this.init();
    this.pathSize();
    this.bindEvent($(window), "load", function () {
      setTimeout(this.fixFn(this.checkScroll), 10);
    });
    if (this.settings.lazyCheckScroll > 0) {
      setInterval(this.fixFn(this.checkScroll), this.settings.lazyCheckScroll);
    }
  }
  _ClassyScroll.prototype.checkScroll = function () {
    this.vtrack = this.vpath.height() - this.vslider.height();
    this.htrack = this.hpath.width() - this.hslider.width();
    this.vdiff = this.content.height() - this.container.height();
    this.hdiff = this.content.width() - this.container.width();
    if (!this.settings.autoHide) return;
    if (this.vdiff > 0) {
      this.vpath.fadeIn(this.settings.autoHideTime);
    } else {
      this.vpath.fadeOut(this.settings.autoHideTime);
    }
    if (this.hdiff > 0) {
      this.hpath.fadeIn(this.settings.autoHideTime);
    } else {
      this.hpath.fadeOut(this.settings.autoHideTime);
    }
  };
  _ClassyScroll.prototype.pathSize = function () {
    var a = parseInt(this.settings.pathPadding, 10);
    this.vpath.css({
      top: a + "px",
      height: this.container.height() - 2 * a + "px"
    });
    this.hpath.css({
      left: a + "px",
      width: this.container.width() - 2 * a + "px"
    });
  };
  _ClassyScroll.prototype.scroll = function (v, h, e) {
    var a = 0;
    var b = 0;
    if (v < 0) {
      v = 0;
    }
    if (v > this.vtrack) {
      v = this.vtrack;
    }
    this.vslider.css("top", v + "px");
    if (h < 0) {
      h = 0;
    }
    if (h > this.htrack) {
      h = this.htrack;
    }
    this.hslider.css("left", h + "px");
    if (this.vdiff > 0) {
      b = v / this.vtrack;
      this.content.css("top", Math.round(-this.vdiff * b));
      if (e && (v && v != this.vtrack)) {
        e.stopPropagation();
        e.preventDefault();
      }
    }
    if (this.hdiff > 0) {
      a = h / this.htrack;
      this.content.css("left", Math.round(-this.hdiff * a));
      if (e && (h && h != this.htrack)) {
        e.stopPropagation();
        e.preventDefault();
      }
    }
    if (this.before.v != b || this.before.h != a) {
      if (typeof this.settings.onscroll == "function") {
        this.settings.onscroll.call(this.container.get(0), b, a);
      }
      this.before.v = b;
      this.before.h = a;
    }
  };
  _ClassyScroll.prototype.easeScroll = function (v, h) {
    var n = 0;
    var a = Math.floor(this.settings.scrollTime / this.settings.scrollInterval);
    var b = this.vslider.position().top;
    var c = this.hslider.position().left;
    var d = $.easing[this.settings.scrollEasing] || $.easing.linear;
    this.sliders.stop().fadeTo(this.settings.sliderOpacityTime, 1);
    window.clearInterval(this.timer);
    this.timer = window.setInterval(
      this.fixFn(function () {
        this.scroll(b + d(n / a, n, 0, 1, a) * v, c + d(n / a, n, 0, 1, a) * h);
        if (++n > a) {
          window.clearInterval(this.timer);
          this.sliders
            .stop()
            .fadeTo(
              this.settings.sliderOpacityTime,
              this.settings.sliderOpacity
            );
        }
      }),
      this.settings.scrollInterval
    );
  };
  _ClassyScroll.prototype.fixFn = function (f, s) {
    var a = this;
    return function () {
      f.apply(s || a, Array.prototype.slice.call(arguments));
    };
  };
  _ClassyScroll.prototype.bindEvent = function (t, e, f, s) {
    return t.bind(e, this.fixFn(f, s));
  };
  _ClassyScroll.prototype.init = function () {
    var f = $(window.document);
    this.bindEvent(this.sliders, "mousedown", function (e) {
      this.pressed = e.target === this.vslider.get(0) ? 1 : 2;
      var a = e.pageX;
      var b = e.pageY;
      var c = this.vslider.position().top;
      var d = this.hslider.position().left;
      this.bindEvent(f, "mousemove", function (e) {
        if (this.pressed == 1) {
          this.scroll(c + (e.pageY - b), d);
        } else {
          this.scroll(c, d + (e.pageX - a));
        }
      });
      this.bindEvent(f, "selectstart", function (e) {
        e.preventDefault();
      });
    });
    this.bindEvent(f, "mouseup", function (e) {
      if (this.pressed == 1 && e.target !== this.vslider.get(0)) {
        this.vslider.fadeTo(
          this.settings.sliderOpacityTime,
          this.settings.sliderOpacity
        );
      } else if (this.pressed == 2 && e.target !== this.hslider.get(0)) {
        this.hslider.fadeTo(
          this.settings.sliderOpacityTime,
          this.settings.sliderOpacity
        );
      }
      this.pressed = 0;
      f.unbind("mousemove");
      f.unbind("selectstart");
    });
    this.bindEvent(this.container, "touchstart", function (e) {
      var a = e.originalEvent;
      var b = a.changedTouches[0];
      this.touch.sx = b.pageX;
      this.touch.sy = b.pageY;
      this.touch.sv = this.vslider.position().top;
      this.touch.sh = this.hslider.position().left;
      this.sliders.stop().fadeTo(this.settings.sliderOpacityTime, 1);
      a.stopPropagation();
    });
    this.bindEvent(this.container, "touchmove", function (e) {
      var a = e.originalEvent;
      var b = a.targetTouches[0];
      this.scroll(
        this.touch.sv + (this.touch.sy - b.pageY) * this.settings.touchSpeed,
        this.touch.sh + (this.touch.sx - b.pageX) * this.settings.touchSpeed
      );
      a.preventDefault();
      a.stopPropagation();
    });
    this.bindEvent(this.container, "touchend touchcancel", function (e) {
      var a = e.originalEvent;
      var b = a.changedTouches[0];
      this.sliders
        .stop()
        .fadeTo(this.settings.sliderOpacityTime, this.settings.sliderOpacity);
      a.stopPropagation();
    });
    var g = this.vpath.height(),
      htrack = this.hpath.width();
    this.bindEvent($(window), "resize", function () {
      this.pathSize();
      this.checkScroll();
      if (this.vdiff <= 0) {
        this.content.css("top", 0);
      }
      if (this.hdiff <= 0) {
        this.content.css("left", 0);
      }
      this.scroll(
        Math.round(
          (parseInt(this.vslider.css("top"), 10) * this.vpath.height()) / g
        ),
        Math.round(
          (parseInt(this.hslider.css("left"), 10) * this.hpath.width()) / htrack
        )
      );
      g = this.vpath.height();
      htrack = this.hpath.width();
    });
    this.bindEvent(this.container, "mousewheel", function (e, a, b, c) {
      this.scroll(
        this.vslider.position().top - this.settings.wheelSpeed * c,
        this.hslider.position().left + this.settings.wheelSpeed * b,
        e
      );
      this.sliders.stop().fadeTo(this.settings.sliderOpacityTime, 1);
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(
        this.fixFn(function () {
          this.sliders
            .stop()
            .fadeTo(
              this.settings.sliderOpacityTime,
              this.settings.sliderOpacity
            );
        }),
        this.settings.sliderOpacityDelay
      );
      if (this.settings.blockGlobalScroll && (this.vdiff || this.hdiff)) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
    this.bindEvent(f, "keydown", function (e) {
      var a = 0,
        vkey = 0;
      vkey = e.keyCode == 38 ? -this.settings.keyScroll : vkey;
      vkey = e.keyCode == 40 ? this.settings.keyScroll : vkey;
      a = e.keyCode == 37 ? -this.settings.keyScroll : a;
      a = e.keyCode == 39 ? this.settings.keyScroll : a;
      if (vkey || a) {
        this.easeScroll(vkey, a);
      }
    });
    this.bindEvent(this.container, "uscrollbar", function (e, v, h, a) {
      if (v === "reset") {
        this.container
          .find(".scrollbar-content, .scrollbar-handle")
          .stop()
          .css({
            top: 0,
            left: 0
          });
        return;
      }
      v = v || 0;
      h = h || 0;
      e.stopPropagation();
      if (/^[-\d\.]+$/.test(v)) {
        v = parseFloat(v);
        if (Math.abs(v) <= 1 && !a) {
          v *= this.vtrack;
        } else {
          v = v + v * (this.vtrack / this.vdiff - 1);
        }
      }
      if (/^[-\d\.]+$/.test(h)) {
        h = parseFloat(h);
        if (Math.abs(h) <= 1 && !a) {
          h *= this.htrack;
        } else {
          h = h + h * (this.htrack / this.hdiff - 1);
        }
      }
      this.easeScroll(v, h);
    });
  };
  $.fn.ClassyScroll = function (s) {
    var a = {
      scroll: "both",
      autoHide: true,
      autoHideTime: "fast",
      lazyCheckScroll: 1000,
      blockGlobalScroll: false,
      contentFilter: "*",
      sliderSize: "30%",
      sliderOpacity: 0.5,
      sliderOpacityTime: 200,
      sliderOpacityDelay: 1000,
      wheelSpeed: 20,
      touchSpeed: 0.3,
      pathPadding: "20px",
      keyScroll: 100,
      scrollTime: 500,
      scrollInterval: 15,
      scrollEasing: "swing",
      zIndex: 100,
      onscroll: function () { }
    };
    $.extend(a, s);
    return this.each(function () {
      new _ClassyScroll(this, a);
    });
  };
})(jQuery);

/*! Copyright (c) 2011 Brandon Aaron (http://brandonaaron.net)
 * Licensed under the MIT License (LICENSE.txt).
 *
 * Thanks to: http://adomas.org/javascript-mouse-wheel/ for some pointers.
 * Thanks to: Mathias Bank(http://www.mathias-bank.de) for a scope bug fix.
 * Thanks to: Seamus Leahy for adding deltaX and deltaY
 *
 * Version: 3.0.6
 *
 * Requires: 1.2.2+
 */

(function ($) {
  var types = ["DOMMouseScroll", "mousewheel"];

  if ($.event.fixHooks) {
    for (var i = types.length; i;) {
      $.event.fixHooks[types[--i]] = $.event.mouseHooks;
    }
  }

  $.event.special.mousewheel = {
    setup: function () {
      if (this.addEventListener) {
        for (var i = types.length; i;) {
          this.addEventListener(types[--i], handler, false);
        }
      } else {
        this.onmousewheel = handler;
      }
    },

    teardown: function () {
      if (this.removeEventListener) {
        for (var i = types.length; i;) {
          this.removeEventListener(types[--i], handler, false);
        }
      } else {
        this.onmousewheel = null;
      }
    }
  };

  $.fn.extend({
    mousewheel: function (fn) {
      return fn ? this.bind("mousewheel", fn) : this.trigger("mousewheel");
    },

    unmousewheel: function (fn) {
      return this.unbind("mousewheel", fn);
    }
  });

  function handler(event) {
    var orgEvent = event || window.event,
      args = [].slice.call(arguments, 1),
      delta = 0,
      returnValue = true,
      deltaX = 0,
      deltaY = 0;
    event = $.event.fix(orgEvent);
    event.type = "mousewheel";

    // Old school scrollwheel delta
    if (orgEvent.wheelDelta) {
      delta = orgEvent.wheelDelta / 120;
    }
    if (orgEvent.detail) {
      delta = -orgEvent.detail / 3;
    }

    // New school multidimensional scroll (touchpads) deltas
    deltaY = delta;

    // Gecko
    if (
      orgEvent.axis !== undefined &&
      orgEvent.axis === orgEvent.HORIZONTAL_AXIS
    ) {
      deltaY = 0;
      deltaX = -1 * delta;
    }

    // Webkit
    if (orgEvent.wheelDeltaY !== undefined) {
      deltaY = orgEvent.wheelDeltaY / 120;
    }
    if (orgEvent.wheelDeltaX !== undefined) {
      deltaX = (-1 * orgEvent.wheelDeltaX) / 120;
    }

    // Add event and delta to the front of the arguments
    args.unshift(event, delta, deltaX, deltaY);

    return ($.event.dispatch || $.event.handle).apply(this, args);
  }
})(jQuery);

/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function () {
  var selectors = {
    edit: ".js-edit-toggle"
  };
  var config = {
    showClass: "cart__update--show",
    showEditClass: "cart__edit--active",
    cartNoCookies: "cart--no-cookies"
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this.$edit.on("click", this._onEditClick.bind(this));
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function () {
      this.$edit.off("click", this._onEditClick);
    },

    _onEditClick: function (evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $("." + $evtTarget.data("target"));

      $evtTarget.toggleClass(config.showEditClass);
      $updateLine.toggleClass(config.showClass);
    },

    cookiesEnabled: function () {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = "testcookie";
        cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function () {
  var constants = {
    SORT_BY: "sort_by"
  };
  var selectors = {
    filterSelection: "#SortTags",
    sortSelection: "#SortBy",
    defaultSort: "#DefaultSortBy"
  };

  function Filters(container) {
    var $container = (this.$container = $(container));

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    );

    this.defaultSort = this._getDefaultSortValue();
    this._resizeSelect(this.$selects);
    this.$selects.removeClass("hidden");

    this.$filterSelect.on("change", this._onFilterChange.bind(this));
    this.$sortSelect.on("change", this._onSortChange.bind(this));
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _onSortChange: function (evt) {
      var sort = this._sortValue();
      if (sort.length) {
        window.location.search = sort;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = window.location.href.replace(
          window.location.search,
          ""
        );
      }
      this._resizeSelect($(evt.target));
    },

    _onFilterChange: function (evt) {
      var filter = this._getFilterValue();

      // remove the 'page' parameter to go to the first page of results
      var search = document.location.search.replace(/\?(page=\w+)?&?/, "");

      // only add the search parameters to the url if they exist
      search = search !== "" ? "?" + search : "";

      document.location.href = filter + search;
      this._resizeSelect($(evt.target));
    },

    _getFilterValue: function () {
      return this.$filterSelect.val();
    },

    _getSortValue: function () {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function () {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function () {
      var sort = this._getSortValue();
      var query = "";

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + "=" + sort;
      }

      return query;
    },

    _resizeSelect: function ($selection) {
      $selection.each(function () {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find("option:selected").text();
        var $test = $("<span>").html(text);

        // add to body, get width, and get out
        $test.appendTo("body");
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function () {
      this.$filterSelect.off("change", this._onFilterChange);
      this.$sortSelect.off("change", this._onSortChange);
    }
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function () {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function () {
      theme.Header.unload();
    }
  });

  return Header;
})();

theme.Maps = (function () {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: "[data-map]",
    mapOverlay: "[data-map-overlay]"
  };

  var classes = {
    mapError: "map-section--load-error",
    errorMsg: "map-section__error errors text-center"
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function () {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
      classes.errorMsg +
      '">' +
      theme.strings.authError +
      "</div>"
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data("api-key");

    if (typeof this.key === "undefined") {
      return;
    }

    if (apiStatus === "loaded") {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== "loading") {
        apiStatus = "loading";
        if (typeof window.google === "undefined") {
          $.getScript(
            "https://maps.googleapis.com/maps/api/js?key=" + this.key
          ).then(function () {
            apiStatus = "loaded";
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function (index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data("address-setting");

    geocoder.geocode({ address: address }, function (results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function () {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function (results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(
              window,
              "resize",
              $.debounce(250, function () {
                google.maps.event.trigger(map, "resize");
                map.setCenter(center);
                $map.removeAttr("style");
              })
            );
          }.bind(this)
        )
        .fail(function () {
          var errorMessage;

          switch (status) {
            case "ZERO_RESULTS":
              errorMessage = errors.addressNoResults;
              break;
            case "OVER_QUERY_LIMIT":
              errorMessage = errors.addressQueryLimit;
              break;
            case "REQUEST_DENIED":
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                classes.errorMsg +
                '">' +
                errorMessage +
                "</div>"
              );
          }
        });
    },

    onUnload: function () {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, "resize");
    }
  });

  return Map;
})();

/* eslint-disable no-new */
theme.Product = (function () {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: "screen and (min-width: 750px)",
      mediaQuerySmall: "screen and (max-width: 749px)",
      bpSmall: false,
      enableHistoryState: $container.data("enable-history-state") || false,
      namespace: ".slideshow-" + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: ".AddToCart-" + sectionId,
      addToCartText: ".AddToCartText-" + sectionId,
      comparePrice: "#ComparePrice-" + sectionId,
      originalPrice: "#ProductPrice-" + sectionId,
      SKU: ".product-detail__sku1",
      originalPriceWrapper: ".product-price__price-" + sectionId,
      originalSelectorId: "#ProductSelect-" + sectionId,
      productImageWraps: ".product-single__photo",
      productPrices: ".product-single__price-" + sectionId,
      productThumbImages: ".product-single__thumbnail--" + sectionId,
      productThumbs: ".product-single__thumbnails-" + sectionId,
      saleClasses: "product-price__sale product-price__sale--single",
      saleLabel: ".product-price__sale-label-" + sectionId,
      singleOptionSelector: ".single-option-selector-" + sectionId
    };

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$("#ProductJson-" + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById("ProductJson-" + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      "js-zoom-enabled"
    );

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._setActiveThumbnail();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function () {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function () {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function () {
          // initialize thumbnail slider on mobile if more than three thumbnails
          if ($(self.selectors.productThumbImages).length > 3) {
            self._initThumbnailSlider();
          }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function () {
              _destroyZoom(this);
            });
          }

          self.settings.bpSmall = true;
        },
        unmatch: function () {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function () {
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function () {
              _enableZoom(this);
            });
          }
        }
      });
    },

    _initVariants: function () {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data("enable-history-state") || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        "variantPageLoad" + this.settings.namespace,
        this._updateAddToCart.bind(this)
      );
      this.$container.on(
        "variantChange" + this.settings.namespace,
        this._updateAddToCart.bind(this)
      );
      this.$container.on(
        "variantImageChange" + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        "variantPriceChange" + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        "variantSKUChange" + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },

    _initImageSwitch: function () {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages).on("click", function (evt) {
        evt.preventDefault();
        var $el = $(this);

        var imageId = $el.data("thumbnail-id");

        self._switchImage(imageId);
        self._setActiveThumbnail(imageId);
      });
    },

    _setActiveThumbnail: function (imageId) {
      var activeClass = "active-thumb";

      // If there is no element passed, find it by the current product image
      if (typeof imageId === "undefined") {
        imageId = $(this.selectors.productImageWraps + ":not('.hide')").data(
          "image-id"
        );
      }

      var $thumbnail = $(
        this.selectors.productThumbImages +
        "[data-thumbnail-id='" +
        imageId +
        "']"
      );
      $(this.selectors.productThumbImages).removeClass(activeClass);
      $thumbnail.addClass(activeClass);
    },

    _switchImage: function (imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
        ":not([data-image-id='" +
        imageId +
        "'])",
        this.$container
      );
      $newImage.removeClass("hide");
      $otherImages.addClass("hide");
    },

    _initThumbnailSlider: function () {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: ".thumbnails-slider__prev--" + this.settings.sectionId,
        nextArrow: ".thumbnails-slider__next--" + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

      $(this.selectors.productThumbs).slick(options);
      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function () {
      $(this.selectors.productThumbs).slick("unslick");
      this.settings.sliderActive = false;
    },

    _updateAddToCart: function (evt) {
      var variant = evt.variant;

      if (variant) {
        var producttype = this.productSingleObject.type;
        if (variant.id == 7943202832445 || variant.id == 7943202766909 || variant.id == 7943202799677 || variant.id == 7943202865213) {
          console.log('Gift Cart Product');
        } else {
          var data_qty = parseInt($('#ProductSelect-product-template option[value="' + variant.id + '"]').attr('data-invqty'));
          var data_out_stock = parseInt($('#ProductSelect-product-template option[value="' + variant.id + '"]').attr('data-out-of-stock'));

          console.log('Inventory Quantity: ' + data_qty);
          console.log('Out of Stock Threshold: ' + data_out_stock);
          console.log('Variant Available: ' + variant.available);

          $(".iStock-wrapper").hide();
          $(this.selectors.productPrices).removeClass('visibility-hidden').attr('aria-hidden', 'true');

          if (producttype.toLowerCase().indexOf("eyeglasses") >= 0) {
            setTimeout(function () {
              $('.AddToCart-product-template').text('Currently Only Sold In Stores');
              $(".iStock-wrapper").hide();
            }, 300);

          } else if (data_qty > data_out_stock) {
            console.log("%cVariant In Stock", "color: #4caf50");
            $(".AddToCart-product-template").prop("disabled", false);
            $('.AddToCart-product-template').text(theme.strings.addToCart);
            $(".iStock-wrapper").hide();

          } else if (data_qty >= 0 && data_qty <= data_out_stock) {
            setTimeout(function () {
              console.log("%cVariant Below Stock Threshold", "color: #ffeb3b");
              $(".AddToCart-product-template").prop("disabled", true);
              $(".AddToCart-product-template").text(theme.strings.soldOut);
              $(".iStock-wrapper").show();
            }, 300);

          } else if (data_qty === -1) {
            setTimeout(function () {
              console.log("%cVariant Sold Out", "color: #f44336");
              $(".AddToCart-product-template").prop("disabled", true);
              $(".AddToCart-product-template").text(theme.strings.soldOut);
              $(".iStock-wrapper").hide();
            }, 300);

          } else {
            // The variant doesn't exist or unavailable, disable submit button and change the text.
            setTimeout(function () {
              console.log("%cSome Other Issue!", "color: #f44336");
              $(".AddToCart-product-template").prop("disabled", true);
              $(".AddToCart-product-template").text(theme.strings.soldOut);
              $(".iStock-wrapper").hide();
            }, 300);
          }
        }
      } else {
        setTimeout(function () {
          $(".AddToCart-product-template").prop("disabled", true);
          $(".AddToCart-product-template").text("Unavailable");
          $(".iStock-wrapper").css('display', 'none');
        }, 300);
      }
    },

    _updateImages: function (evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    _updatePrice: function (evt) {
      var variant = evt.variant;

      // Update the product price
      $(this.selectors.originalPrice).html(
        theme.Currency.formatMoney(variant.price, theme.moneyFormat)
      );

      if ($(".mini-prod-sticky").length > 0) {
        $(".mini-prod-sticky .product-detail__price").html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
      }

      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice)
          .html(
            theme.Currency.formatMoney(
              variant.compare_at_price,
              theme.moneyFormat
            )
          )
          .removeClass("hide");

        $(this.selectors.originalPriceWrapper).addClass(
          this.selectors.saleClasses
        );
        $(this.selectors.saleLabel).removeClass("hide");
        $(this.selectors.productPrices)
          .find(".save_discount_pro")
          .removeClass("hide");
        var priceSaving =
          "Save " +
          (
            ((variant.compare_at_price - variant.price) /
              variant.compare_at_price) *
            100
          ).toFixed() +
          "%";
        $(this.selectors.productPrices)
          .find(".save_discount_pro")
          .html('<span class="per_discount">' + priceSaving + "</span>");
      } else {
        $(this.selectors.comparePrice).addClass("hide");
        $(this.selectors.saleLabel).addClass("hide");
        $(this.selectors.productPrices)
          .find(".save_discount_pro")
          .addClass("hide");
        $(this.selectors.originalPriceWrapper).removeClass(
          this.selectors.saleClasses
        );
      }
    },

    _updateSKU: function (evt) {
      var variant = evt.variant;
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.SKU).html("SKU :" + variant.sku);
        $("#saleitem").attr("name", "properties[saleitem]");
        $("#saleitem").val(1);
      } else {
        $(this.selectors.SKU).html("");
        $("#saleitem").attr("name", "notsaleiteam");
      }
      // Update the sku
    },

    onUnload: function () {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data("zoom");
    $(el).zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom(el) {
    $(el).trigger("zoom.destroy");
  }

  return Product;
})();

theme.Quotes = (function () {
  var config = {
    mediaQuerySmall: "screen and (max-width: 749px)",
    mediaQueryMediumUp: "screen and (min-width: 750px)",
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Quotes(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");
    var wrapper = (this.wrapper = ".quotes-wrapper");
    var slider = (this.slider = "#Quotes-" + sectionId);
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data("count");

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on("init", this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function () {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function () {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick("unslick");
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function () {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick("unslick");
    },

    onBlockSelect: function (evt) {
      // Ignore the cloned version
      var $slide = $(
        ".quotes-slide--" + evt.detail.blockId + ":not(.slick-cloned)"
      );
      var slideIndex = $slide.data("slick-index");

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick("slickGoTo", slideIndex);
    },

    a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr("aria-live");

      // When an element in the slider is focused set aria-live
      $wrapper.on("focusin", function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr("aria-live", "polite");
        }
      });

      // Remove aria-live
      $wrapper.on("focusout", function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr("aria-live");
        }
      });
    }
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function () {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");
    var slideshow = (this.slideshow = "#Slideshow-" + sectionId);

    $(".slideshow__video", slideshow).each(function () {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr("id"));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function () {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function (evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(
        ".slideshow__slide--" + evt.detail.blockId + ":not(.slick-cloned)"
      );
      var slideIndex = $slide.data("slick-index");

      // Go to selected slide, pause autoplay
      $slideshow.slick("slickGoTo", slideIndex).slick("slickPause");
    },

    onBlockDeselect: function () {
      // Resume autoplay
      $(this.slideshow).slick("slickPlay");
    }
  }
);

$(document).ready(function () {
  var sections = new theme.Sections();

  sections.register("cart-template", theme.Cart);
  sections.register("product", theme.Product);
  sections.register("collection-template", theme.Filters);
  sections.register("product-template", theme.Product);
  sections.register("header-section", theme.HeaderSection);
  sections.register("map", theme.Maps);
  sections.register("slideshow-section", theme.SlideshowSection);
  sections.register("quotes", theme.Quotes);

  $(".newsletter-section form").on("submit", function (e) {
    var thankyou = $(this)
      .closest(".newsletter-section")
      .find("[data-newsletter-thankyou]");
    var form = $(this);
    e.preventDefault();
    var email = $(this)
      .find("input[name='contact[email]']")
      .val();
    var settings = {
      async: true,
      crossDomain: true,
      //"url": "https://manage.kmail-lists.com/subscriptions/external/subscribe",
      url: "https://a.klaviyo.com/api/v2/list/QzeVRF/subscribe",
      method: "POST",
      headers: {
        "content-type": "application/json",
        "cache-control": "no-cache"
      },
      data: {
        api_key: "pk_88cd5f8509a5bf40ab835778377c036ec6",
        email: email
      }
    };
    $.ajax(settings)
      .done(function (response) {
        form[0].reset();

        if (response.success == true) {
          thankyou.addClass("active");
          thankyou.text(
            "Welcome! Please check your email for more information and great offers from RAEN."
          );
        }
      })
      .fail(function (textStatus) {
        thankyou.addClass("active");
        thankyou.text("Thank you! You are already subscribed.");
      });

    setTimeout(function () {
      thankyou.removeClass("active");
    }, 8500);
  });

  $(".newsletter-popup-content-form form").on("submit", function (e) {
    var thankyou1 = $(this)
      .closest(".newsletter-popup-content-form")
      .find("[data-newsletter-thankyou]");
    var thankyou_popinfo = $(this)
      .closest(".newsletter-popup-content-form")
      .find(".newsletter-popup__info");
    var thankyou_dismiss = $(this)
      .closest(".newsletter-popup-content-form")
      .find(".newsletter-popup-content-manipulate .newsletter-popup__close");

    var form1 = $(this);
    e.preventDefault();
    var email = $(this)
      .find("input[name='contact[email]']")
      .val();
    var settings = {
      async: true,
      crossDomain: true,
      //"url": "https://manage.kmail-lists.com/subscriptions/external/subscribe",
      url: "https://a.klaviyo.com/api/v2/list/QzeVRF/subscribe",
      method: "POST",
      headers: {
        "content-type": "application/json",
        "cache-control": "no-cache"
      },
      data: {
        api_key: "pk_88cd5f8509a5bf40ab835778377c036ec6",
        email: email
      }
    };
    $.ajax(settings)
      .done(function (response) {
        form1[0].reset();
        if (response.success == true) {
          form1.hide();
          thankyou1.addClass("active");
          thankyou1.addClass("form--success");
          thankyou_popinfo.addClass("bottom-padding-0");
          thankyou_popinfo
            .find(".h1")
            .text("Welcome To RAEN")
            .addClass("text-center");
          thankyou_popinfo.find("> p").hide();
          //       thankyou.text('Welcome! Please check your email for your offer code.');
          thankyou1
            .html(
              '<p>Use code</p><div class="code">WELCOME20</div><p>at checkout to save 20%</p>'
            )
            .addClass("newsletter-popup__code");
          thankyou_dismiss.html(
            "*Valid for the next 24 hours.<br>Cannot be combined with any other offer.<br>Exclude Sale Items."
          );
          var todaytimeStamp = Math.floor(Date.now());
          localStorage.setItem("todaytimestemp", todaytimeStamp);
          var aftertday = todaytimeStamp + 3 * 24 * 60 * 60 * 1000;
          localStorage.setItem("threedaytimestemp", aftertday);
        }
      })
      .fail(function (textStatus) {
        thankyou1.addClass("active");
        thankyou1.addClass("popup-suc");
        //thankyou.addClass('form--success');
        thankyou1.text("Thank you! You are already subscribed.");
        form1.show();
      });

    //   setTimeout(function() {
    //     thankyou1.removeClass('active');
    //     form1.show();
    //   }, 8500);
  });

  $(document).on("click", ".newsletter-popup__close-x1", function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });
});

theme.init = function () {
  theme.customerTemplates.init();

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = ".rte table," + ".custom__item-inner--html table";

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: "scrollable-wrapper"
  });

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: "video-wrapper"
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $(".in-page-link").on("click", function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on("click", function (evt) {
    evt.preventDefault();
  });
};

$(document).on("click", ".filters-show-hide", function (e) {
  $(".collection-wrap").toggleClass("filters-hidden");
  //$( ".collection-view > span" ).toggle();
});

/*----- Product Slider -----*/
lightGallery(document.getElementById("featuredPostSlider1"), {
  thumbnail: true,
  download: false
});

// lightGallery(document.getElementById('featuredPostSlider2'), {});

function slickHeight() {
  var winWidth = $(window).width();
  if (winWidth > 1023) {
    var sliderHeight = $(".slick-slider").height();
    $("#slick-pager .slick-pager").css("height", sliderHeight - 60);
  }
}
$(window).resize(function () {
  slickHeight();
});
jQuery(document).ready(function ($) {
  $(".featuredPostSlider").slick({
    accessibility: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    fade: true,
    asNavFor: ".slick-pager"
  });
  $(".slick-pager").slick({
    slidesToShow: 8,
    slidesToScroll: 1,
    infinite: false,
    //nextArrow: $('.pagerNavigation .bottom'),
    //prevArrow: $('.pagerNavigation .top'),
    asNavFor: ".featuredPostSlider",
    focusOnSelect: true,
    vertical: true,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          vertical: false
        }
      }
    ]
  });

  $(".slick-pager .slick-track > *").each(function (e) {
    if (
      $(this)
        .find(".product_thumbnails")
        .hasClass("dd-thumbslide-vdo")
    ) {
      $("#featuredPostSlider .slick-dots li:eq(" + e + ")").addClass("dot_vdo");
    }
  });

  $(document).on("click", ".slick-pager .slick-track > *", function (e) {
    var ev = $(this).attr("data-slick-index");
    console.log(ev);
    var iframeSrc = $(
      '#featuredPostSlider .resp-container[data-slick-index="' +
      ev +
      '"] iframe'
    ).attr("src");
    console.log(iframeSrc);
    if (iframeSrc.indexOf("autoplay") > -1) {
    } else {
      iframeSrc += "&autoplay=1&loop=1&autopause=0";
      $(
        '#featuredPostSlider .resp-container[data-slick-index="' +
        ev +
        '"] iframe'
      ).attr("src", iframeSrc);
    }
  });

  $(".swatch_mob_slider").owlCarousel({
    nav: true,
    touchDrag: false,
    mouseDrag: false,
    slidesToScroll: 4,
    responsive: {
      0: {
        items: 3,
        slideBy: 3
      },
      600: {
        items: 4,
        slideBy: 4
      },
      1000: {
        items: 4,
        slideBy: 4
      }
    }
  });
  $(".swatch_mob_slider_article").owlCarousel({
    nav: true,
    slidesToScroll: 3,
    responsive: {
      0: {
        items: 3,
        slideBy: 3
      },
      600: {
        items: 3,
        slideBy: 3
      },
      1000: {
        items: 3,
        slideBy: 3
      }
    }
  });

  $(".swatch.dd_color .swatch_desktop_slider").slick({
    slidesToShow: 3,
    loop: false,
    infinite: false,
    slidesToScroll: 3,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });
  $(".swatch_article_slider").slick({
    slidesToShow: 3,
    loop: false,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });
  $(
    ".pro_slick-pager .slick-list .slick-track .slick-slide:eq(0) .product_thumbnails"
  )
    .find()
    .trigger("click");
});

$(document).on("click", "#featuredPostSlider a", function (e) {
  e.preventDefault();
  var data_imgid = $(this).attr("data-imgid");
  //$('#featuredPostSlider1 a[data-imgid="'+data_imgid+'"] img').trigger('click');
  $('#featuredPostSlider2 a[data-imgid="' + data_imgid + '"]').trigger("click");

  var imgindexdd = $(this)
    .closest(".slick-slide")
    .data("slick-index");
  $(
    '.html5-nav-list .html5-nav-thumb[data-arrayindex="' + imgindexdd + '"]'
  ).addClass("activethumb");
});

$(".ambassador-slider").owlCarousel({
  loop: true,
  margin: 50,
  nav: true,
  dotsEach: true,
  responsiveClass: true,
  responsive: {
    0: {
      items: 1,
      margin: 30,
      nav: false
    },
    600: {
      margin: 20,
      items: 2
    },
    1000: {
      items: 2
    }
  }
});

$(".featured-posts-slider").owlCarousel({
  animateOut: "fadeOut",
  autoplay: false,
  autoHeight: true,
  autoplayTimeout: 3000,
  loop: true,
  margin: 0,
  mouseDrag: false,
  nav: true,
  dots: false,
  navContainer: ".featured-posts__toggle",
  navText: [],
  responsive: {
    0: {
      items: 1
    },
    600: {
      items: 1
    },
    1000: {
      items: 1
    }
  }
});

$(function () {
  // if($('.template-product').length > 0){
  //   $('.popup-modal').magnificPopup({
  //     type: 'inline',
  //     preloader: false,
  //     focus: '#username',
  //     modal: true
  //   });
  // }

  $(document).on("click", ".popup-modal-dismiss", function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });

  $(".product-tile__quickview").magnificPopup({
    type: "inline",
    preloader: false,
    //   modal: true,
    closeOnBgClick: true,
    enableEscapeKey: true
  });
});

// if($('.template-collection').length > 0){
//   $(document).on('click', '.popup-modal-dismiss', function (e) {
//     e.preventDefault();
//     $.magnificPopup.close();
//   });
// }

/*$('.blog-gallery-slider').slick({
  dots: true,
  infinite: true,
  speed: 700,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        dots: false
      }
    }
  ]
});*/

$(".lookbook-detail-gallery").slick({
  dots: false,
  infinite: true,
  speed: 700,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        dots: false
      }
    }
  ]
});

$(".lookbook-detail-gallery").on("afterChange", function (
  event,
  slick,
  currentSlide,
  nextSlide
) {
  console.log("currentSlide: " + currentSlide);
  $(".lookbook-detail-controls__text > span").text(currentSlide + 1);
});

$(document).on("click", ".lookbook-detail-thumbnails a[data-slide]", function (
  e
) {
  e.preventDefault();
  var slideno = $(this).data("slide");
  $(".lookbook-detail-controls-holder").show();
  $(".lookbook-detail-main, .lookbook-detail-controls__close").removeClass(
    "thumbnails-active"
  );
  $(".lookbook-detail-gallery").slick("slickGoTo", slideno - 1);
});

$(document).on(
  "click",
  ".lookbook-detail-controls__menu,.lookbook-detail-controls__close",
  function () {
    if ($(".lookbook-detail-main").hasClass("thumbnails-active")) {
      $(".lookbook-detail-controls-holder").show();
      $(".lookbook-detail-main, .lookbook-detail-controls__close").removeClass(
        "thumbnails-active"
      );
    } else {
      $(".lookbook-detail-controls-holder").hide();
      $(".lookbook-detail-main, .lookbook-detail-controls__close").addClass(
        "thumbnails-active"
      );
    }
  }
);

$(document).on("click", ".lookbook-detail-controls__nav--next", function () {
  $(".lookbook-detail-gallery .slick-next").trigger("click");
});
$(document).on("click", ".lookbook-detail-controls__nav--prev", function () {
  $(".lookbook-detail-gallery .slick-prev").trigger("click");
});

$(".products-slider").slick({
  dots: false,
  infinite: false,
  speed: 700,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$(document).on("click", ".video-wrapper .feature-video__close", function () {
  $(".custom-content .video-wrapper iframe").css("display", "none");
  var iframedd = $(this)
    .closest(".video-wrapper")
    .find("iframe")
    .prop("src");
  var iframeddurl = iframedd.split("?");
  $(this)
    .closest(".video-wrapper")
    .find("iframe")
    .prop("src", iframeddurl[0]);

  $(this)
    .closest(".video-wrapper")
    .find("img")
    .fadeIn(100, function () {
      $(this)
        .closest(".video-wrapper")
        .find("iframe")
        .css({ "margin-top": "0", "z-index": "0" });
      $(this)
        .closest(".video-wrapper")
        .css("background-color", "#fff");
      $(this)
        .closest(".video-wrapper")
        .find(".play.block__play")
        .show();
    });

  $(this).css({
    opacity: "0",
    visibility: "hidden",
    background: "transparent"
  });
});

$(document).on(
  "click",
  ".custom-content .video-wrapper > img,.play.block__play",
  function () {
    //https://player.vimeo.com/video/65581663?rel=0&autoplay=1
    var video_url = $(this)
      .closest(".video-wrapper")
      .find("iframe")
      .attr("data-src");
    $(this)
      .closest(".video-wrapper")
      .find("iframe")
      .attr("src", video_url);
    $(".custom-content .video-wrapper iframe").css("display", "block");
    $(this).fadeOut(500, function () {
      $(this)
        .closest(".video-wrapper")
        .find("iframe")
        .css({ "margin-top": "0", "z-index": "100" });
      $(this)
        .closest(".video-wrapper")
        .css("background-color", "#fff");
    });

    $(this)
      .closest(".video-wrapper")
      .find(".feature-video__close")
      .css({ opacity: "1", visibility: "visible", background: "transparent" });

    var videoURL2 = $(this)
      .closest(".video-wrapper")
      .find("iframe")
      .prop("src");
    videoURL2 += "?byline=0&portrait=0&badge=0&rel=0&autoplay=1";
    $(this)
      .closest(".video-wrapper")
      .find("iframe")
      .prop("src", videoURL2);
  }
);

jQuery(function () {
  jQuery(".swatch :radio").click(function () {
    var optionIndex = jQuery(this)
      .closest(".swatch")
      .attr("data-option-index");
    var optionValue = jQuery(this).val();
    jQuery(this)
      .closest("form")
      .find(".single-option-selector")
      .eq(optionIndex)
      .val(optionValue)
      .trigger("change");

    jQuery(this)
      .closest(".swatch")
      .find(".option_val")
      .html(optionValue);

    jQuery(
      '.mini-prod-sticky .selector-wrapper .product-form__input[data-index="option' +
      optionIndex +
      '"]'
    )
      .val(optionValue)
      .trigger("change");

    //   [value="'+$(this).val()+'"]').trigger('click').prop('checked',true);
  });
});
$(document).on("click", ".product-detail-tabs-nav__item", function (e) {
  e.preventDefault();
  var det_tab = $(this).attr("data-product-detail-tab");
  $(".product-detail-tabs-nav__item").removeClass("active");
  $(this).addClass("active");
  console.log("click");
  $(".product-detail-tabs-content__item").removeClass("active");
  $(
    '.product-detail-tabs-content__item[data-product-detail-tab-content="' +
    det_tab +
    '"]'
  ).addClass("active");
  var fitGuideSlider = {
    arrows: false,
    autoplay: false,
    centerMode: true,
    centerPadding: "0",
    dots: true,
    draggable: true,
    easing: "swing",
    infinite: false,
    mobileFirst: true,
    respondTo: "window",
    slide: "div",
    slidesToShow: 1,
    swipe: true,
    useCSS: false,
    useTransform: false
  };
  $(".product-detail-tabs-slider__list").slick("unslick");
  $(".product-detail-tabs-slider__list").slick(fitGuideSlider);
});
$(document).on("click", ".story-detail-tabs-nav__item", function (e) {
  e.preventDefault();
  var det_tab = $(this).attr("data-product-detail-tab");
  $(this).toggleClass("active");
  $(
    '.product-detail-tabs-content__item[data-product-detail-tab-content="' +
    det_tab +
    '"]'
  ).toggleClass("active");
});

$(document).on("click", ".product-detail-sizes__fit-guide", function (e) {
  e.preventDefault();
  $('.product-detail-tabs-nav__item[data-product-detail-tab="2"]').trigger(
    "click"
  );
  $("html, body").animate(
    {
      scrollTop:
        $(".product-detail-tabs-tile").offset().top -
        $(".site-header").height() -
        30
    },
    800
  );
});

$("[data-product-options]").each(function () {
  var el = $(this),
    sticky = $("[data-product-options-sticky]");
  $(window)
    .on("load scroll resize", function () {
      var scrollTop = $(window).scrollTop(),
        elementOffset = el.offset().top,
        elementHeight = el.height(),
        offset = elementOffset + elementHeight * 2 - scrollTop,
        stickyHeight = sticky.outerHeight();
      if (offset <= 0) {
        sticky.addClass("product-detail-options--active");
        sticky.css("marginTop", 0);
      } else {
        sticky.removeClass("product-detail-options--active");
        sticky.css("marginTop", -stickyHeight);
      }
    })
    .resize();
});

$(".mini-prod-sticky .selector-wrapper .product-form__input").change(
  function () {
    console.log($(this).val());
    $('.product-single__meta .swatch input[value="' + $(this).val() + '"]')
      .trigger("click")
      .prop("checked", true);
  }
);

$(document).on(
  "click",
  ".mini-prod-sticky button.product-detail-options__button",
  function () {
    $(".product-single__meta .product-form__cart-submit").trigger("click");
  }
);

var fitGuideSlider = {
  arrows: false,
  autoplay: false,
  centerMode: true,
  centerPadding: "0",
  dots: true,
  draggable: true,
  easing: "swing",
  infinite: false,
  mobileFirst: true,
  respondTo: "window",
  slide: "div",
  slidesToShow: 1,
  swipe: true,
  useCSS: false,
  useTransform: false
};
/*$('.product-detail-tabs-slider__list').slick(fitGuideSlider);*/

var shopUrl = "https://raenus.myshopify.com";
var colUrl = window.top.location.href;
if (colUrl.indexOf("filter") > -1) {
} else {
  $(document).on("click", ".product-tile__quickview", function () {
    if ($("#filter-add-class").hasClass("php-filter")) {
    } else {
      var handle = $(this).attr("data-handle");
      var c_price = 0;
      var data_url = $(this).attr("data-url");
      var v_id = $(this).attr("data-vid");
      var data_metafield = $(this).attr("data-metafield");
      var mainImage = "";
      var quickViewMessage = $("#qvDiscountMessage").html();
      // var data_color = "";
      var product_v_qty = $(this)
        .attr("datav_qty")
        .split(",");
      var product_v_hide = $(this)
        .attr("data-hide")
        .split(",");
      var product_max_qty = parseInt($(this).attr("datamax_qty"));
      var selected_variant = $(this).attr("data-first-variant");
      var data_color = $(this).attr("data-color");
      var data_avlcolor = [];
      var numbersArray = data_color.split(",");
      $.each(numbersArray, function (index, value) {
        data_avlcolor[index] = value;
      });
      $("#myModal .modal-dialog").empty();

      $.ajax({
        url: "/products/" + handle + ".js",
        dataType: "json",
        type: "GET",
        success: function (product) {
          var productData = product;
          $.ajax({
            url: "/products/" + handle + ".json"
          }).done(function (data) {
            productData.images = data.product.images;
            var quickViewHtml = "";
            var variant = "";
            var variants = product.variants;
            var firstVariant = variants[0];
            var prd_opt = product.options[0];
            var nub_color = parseInt(prd_opt.values.length);
            mainImage = product.featured_image;

            quickViewHtml += '<div class="modal-content">';
            quickViewHtml += '<div class="modal-header">';
            quickViewHtml +=
              '<button type="button" class="close popup-modal-dismiss icon--cancel"></button>';
            quickViewHtml += "</div>";
            quickViewHtml += '<div class="modal-body">';
            quickViewHtml += '<div class="product-template__container">';
            quickViewHtml += '<div class="grid grid--no-gutters">';
            quickViewHtml +=
              '<div id="divImage" class="product_modal_loader" style="display: block"><img alt="Loading... Please wait!" src="//cdn.shopify.com/s/files/1/0008/6156/9085/t/65/assets/loading.gif" width="100" height="100" /></div>';
            quickViewHtml +=
              '<div class="grid__item product-single__photos medium-up--two-thirds">';
            quickViewHtml += '<div class="quick-slider">';

            for (var image in productData.images) {
              var fstVar = firstVariant.title;
              var prdImgAlt = productData.images[image].alt;
              if (fstVar.indexOf(prdImgAlt) > -1) {
                quickViewHtml +=
                  '<div><div class="pro_img"><img class="product_img" src="' +
                  productData.images[image].src +
                  '"></div></div>';
              }
              if ($.trim(prdImgAlt).length > 45) {
                if (
                  prdImgAlt.indexOf("youtube") > -1 ||
                  prdImgAlt.indexOf("vimeo") > -1
                ) {
                  quickViewHtml +=
                    '<div class="resp-container"><div class="video_wrapper"> <iframe class="resp-iframe" src="' +
                    prdImgAlt +
                    '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div></div>';
                }
              }
            }
            quickViewHtml += "</div>";

            quickViewHtml += '<div class="pro_slick-pager">';
            for (var image in productData.images) {
              var fstVar1 = firstVariant.title;
              var prdImgAlt1 = productData.images[image].alt;
              if (fstVar1.indexOf(prdImgAlt1) > -1) {
                quickViewHtml +=
                  '<div><div class="product_thumbnails" id="product_thumbnails"><img src="' +
                  productData.images[image].src +
                  '" /></div></div>';
              }
              if ($.trim(prdImgAlt1).length > 45) {
                if (
                  prdImgAlt1.indexOf("youtube") > -1 ||
                  prdImgAlt1.indexOf("vimeo") > -1
                ) {
                  quickViewHtml +=
                    '<div><div class="product_thumbnails dd-thumbslide-vdo" id="product_thumbnails"><img src="' +
                    productData.images[image].src +
                    '" /></div></div>';
                }
              }
            }

            quickViewHtml += "</div></div>";

            quickViewHtml +=
              '<div class="grid__item product-detail-info medium-up--one-third">';
            quickViewHtml += '<div class="product-single__meta">';
            quickViewHtml +=
              '<h1 class="product-single__title">' + product.title + "</h1>";
            //       quickViewHtml += '<h3 class="product-detail__type">' + product.type +'</h3>';
            quickViewHtml +=
              '<div class="product-detail__summary summary grid-view-item">';
            quickViewHtml +=
              '<div class="product-shortdesc">' + data_metafield + "</div>";
            quickViewHtml +=
              '<a href="/products/' +
              handle +
              '#stamped-main-widgetnew"><span class="shopify-product-reviews-badge spr-badge" data-id="' +
              productData.id +
              '"></span></a>';
            quickViewHtml +=
              '<p class="product-single__price product-single__price-product-template">';
            if (data.product.product_type != "Eyeglasses") {
              quickViewHtml +=
                '<span class="product-price__price product-price__price-product-template">';
              quickViewHtml +=
                '<span id="ProductPrice-product-template">' +
                theme.Currency.formatMoney(
                  variants[0].price,
                  theme.moneyFormat
                ) +
                "</span>&nbsp&nbsp";
            }
            if (data.product.product_type != "Eyeglasses") {
              quickViewHtml += '<s id="ComparePrice-product-template">';
              if (variants[0].compare_at_price > variants[0].price) {
                quickViewHtml += theme.Currency.formatMoney(
                  variants[0].compare_at_price,
                  theme.moneyFormat
                );
              }
              quickViewHtml += "</s>";
            }
            quickViewHtml += '<p class="a_color">' + nub_color + " Colors </p>";
            quickViewHtml +=
              '<span class="product-price__sale-label product-price__sale-label-product-template hide">Sale</span>';
            quickViewHtml += "</span></p>";
            quickViewHtml +=
              ' <form action="/cart/add" method="post" enctype="multipart/form-data" class="product-form product-form-product-template" data-section="product-template">';
            quickViewHtml +=
              '<select id="product-select-qv" name="id" style="display: none;">';
            for (i = 0; i < product.variants.length; i++) {
              var _var = product.variants[i];
              var variant_aviable = _var.available;
              c_price = 0;

              if (product_v_qty[i] > product_max_qty) {
                variant_aviable = true;
              } else {
                variant_aviable = false;
              }
              if (_var.compare_at_price > _var.price) {
                c_price = _var.compare_at_price;
              }
              if (c_price != 0) {
                quickViewHtml +=
                  '<option value="' +
                  _var.id +
                  '" data-available="' +
                  variant_aviable +
                  '" data-qprice="' +
                  theme.Currency.formatMoney(_var.price, theme.moneyFormat) +
                  '" data-cprice="' +
                  theme.Currency.formatMoney(c_price, theme.moneyFormat) +
                  '">' +
                  _var.title +
                  "</option>";
              } else {
                quickViewHtml +=
                  '<option value="' +
                  _var.id +
                  '" data-available="' +
                  variant_aviable +
                  '" data-qprice="' +
                  theme.Currency.formatMoney(_var.price, theme.moneyFormat) +
                  '" data-cprice="0">' +
                  _var.title +
                  "</option>";
              }
            }
            quickViewHtml += "</select>";

            for (i = 0; i < product.options.length; i++) {
              var prd_opt = product.options[i];
              quickViewHtml += '<div class="select_quick';
              if (prd_opt.values.length < 2) {
                quickViewHtml += ' hide">';
              } else {
                quickViewHtml += '">';
              }

              quickViewHtml += "<label>" + prd_opt.name + ":</label>";
              quickViewHtml +=
                '<select id="product-select-qv-opt-' +
                i +
                '" class="product-select-qv ' +
                prd_opt.name.toLowerCase().replace(/ /g, "-") +
                '" >';
              for (j = 0; j < prd_opt.values.length; j++) {
                var _opt = prd_opt.values[j];
                // var invetory = prd_opt.available[j];
                quickViewHtml +=
                  '<option value="' + _opt + '">' + _opt + "</option>";
              }
              quickViewHtml += "</select></div>";
            }

            var a = new Array();
            if (
              (a.push("Size"),
                (a.push("Color"), a.push("Colour")),
                a.length > 0)
            ) {
              var o = ".png",
                r = !1,
                n = !1,
                s = 0,
                l = window.asset_url.substring(
                  0,
                  window.asset_url.lastIndexOf("?")
                ),
                d = window.asset_url.substring(
                  window.asset_url.lastIndexOf("?"),
                  window.asset_url.length
                );
              var e = product;
              for (i = 0; i < e.options.length; i++) {
                var s_class = "";
                if (i == 0) {
                  s_class = "swatch_mob_slider owl-carousel owl-theme";
                }
                var c = "";
                if (
                  ((c =
                    "object" == typeof e.options[i]
                      ? e.options[i].name
                      : e.options[i]),
                    (r = !1),
                    (n = !1),
                    a.indexOf(c) > -1)
                ) {
                  (r = !0), (s = i);
                  var u = c.toLowerCase();
                  if ((/color|colour/i.test(u) && (n = !0), r)) {
                    var dd = e.variants[0];
                    var ydd = dd.options[i];

                    var h = "",
                      f = ydd;

                    (h +=
                      '<div class="swatch optiondd' +
                      e.options[i].values.length +
                      " " +
                      u +
                      ' clearfix" data-option-index="' +
                      s +
                      '">'),
                      (h +=
                        '<div class="header"><span>' +
                        c +
                        ": </span>" +
                        f +
                        "</div><div class='" +
                        s_class +
                        "'>");
                    var m = new Array();
                    for (j = 0; j < e.variants.length; j++) {
                      var p = e.variants[j];
                      if (!p.featured_image) {
                        continue;
                      }
                      if (product_v_hide[j] == "hide") {
                        console.log(product_v_hide[j]);
                        continue;
                      }
                      var imgsrc = p.featured_image.src;
                      var y = p.options[s],
                        g = y
                          .toLowerCase()
                          .replace(/[^a-z0-9 -]/g, "")
                          .replace(/\s+/g, "-")
                          .replace(/-+/g, "-"),
                        v = "swatch-" + s + "-" + g;
                      var add_class = "ddclass";
                      if (g == v_id) {
                        add_class = "ddtclass";
                      }
                      if (c == "Color") {
                        if (data_avlcolor.indexOf(y) != -1) {
                          //alert('1');
                          m.indexOf(y) < 0 &&
                            ((h +=
                              '<div data-value="' +
                              y +
                              '" id="' +
                              add_class +
                              '" class="swatch-element ' +
                              (n ? "color " : "") +
                              g +
                              (p.available ? " available " : " soldout ") +
                              '">'),
                              n && (h += '<div class="tooltip">' + y + "</div>"),
                              (h +=
                                '<input id="' +
                                v +
                                '" type="radio" name="option-' +
                                s +
                                '" value="' +
                                y +
                                '"' +
                                (0 == j ? " checked " : "") +
                                (p.available ? "" : " ") +
                                "/>"),
                              n
                                ? ((h +=
                                  '<label for="' +
                                  v +
                                  '" class="img"><img src="' +
                                  imgsrc +
                                  '" />'),
                                  (h +=
                                    '<img class="crossed-out" src="' +
                                    l +
                                    'https://cdn.shopify.com/s/files/1/0008/6156/9085/t/20/assets/soldout.png" />'),
                                  (h += "</label>"))
                                : ((h += '<label for="' + v + '">' + y),
                                  (h +=
                                    '<img class="crossed-out" src="' +
                                    l +
                                    'https://cdn.shopify.com/s/files/1/0008/6156/9085/t/20/assets/soldout.png" />'),
                                  (h += "</label>")),
                              (h += "</div>"),
                              m.push(y));
                        } else {
                          //alert('2');
                          m.indexOf(y) < 0 &&
                            ((h +=
                              '<div data-value="' +
                              y +
                              '" id="' +
                              add_class +
                              '" class="swatch-element ' +
                              (n ? "color " : "") +
                              g +
                              (p.available ? " available " : " soldout ") +
                              '">'),
                              n && (h += '<div class="tooltip">' + y + "</div>"),
                              (h +=
                                '<input id="' +
                                v +
                                '" type="radio" name="option-' +
                                s +
                                '" value="' +
                                y +
                                '"' +
                                (0 == j ? " checked " : "") +
                                (p.available ? "" : " ") +
                                "/>"),
                              n
                                ? ((h +=
                                  '<label for="' +
                                  v +
                                  '" class="img"><img src="' +
                                  imgsrc +
                                  '" />'),
                                  (h +=
                                    '<img class="crossed-out" src="' +
                                    l +
                                    'https://cdn.shopify.com/s/files/1/0008/6156/9085/t/20/assets/soldout.png" />'),
                                  (h += "</label>"))
                                : ((h += '<label for="' + v + '">' + y),
                                  (h +=
                                    '<img class="crossed-out" src="' +
                                    l +
                                    'https://cdn.shopify.com/s/files/1/0008/6156/9085/t/20/assets/soldout.png" />'),
                                  (h += "</label>")),
                              (h += "</div>"),
                              m.push(y));
                        }
                      } else {
                        m.indexOf(y) < 0 &&
                          ((h +=
                            '<div data-value="' +
                            y +
                            '" id="' +
                            add_class +
                            '" class="swatch-element ' +
                            (n ? "color " : "") +
                            g +
                            (p.available ? " available " : " soldout ") +
                            '">'),
                            n && (h += '<div class="tooltip">' + y + "</div>"),
                            (h +=
                              '<input id="' +
                              v +
                              '" type="radio" name="option-' +
                              s +
                              '" value="' +
                              y +
                              '"' +
                              (0 == j ? " checked " : "") +
                              (p.available ? "" : " ") +
                              "/>"),
                            n
                              ? ((h +=
                                '<label for="' +
                                v +
                                '" class="img"><img src="' +
                                imgsrc +
                                '" />'),
                                (h +=
                                  '<img class="crossed-out" src="' +
                                  l +
                                  'https://cdn.shopify.com/s/files/1/0008/6156/9085/t/20/assets/soldout.png" />'),
                                (h += "</label>"))
                              : ((h += '<label for="' + v + '">' + y),
                                (h +=
                                  '<img class="crossed-out" src="' +
                                  l +
                                  'https://cdn.shopify.com/s/files/1/0008/6156/9085/t/20/assets/soldout.png" />'),
                                (h += "</label>")),
                            (h += "</div>"),
                            m.push(y));
                      }
                      //m.indexOf(y) < 0 && (h += '<div data-value="' + y + '" id="'+ add_class +'" class="swatch-element ' + add_class + ' ' + (n ? "color" : "") + g + (p.available ? " available " : " soldout ") + '">', n && (h += '<div class="tooltip">' + y + "</div>"), h += '<input id="' + v + '" type="radio" name="option-' + s + '" value="' + y + '"' + (0 == j ? " checked " : "") + (p.available ? "" : "") + "/>", n ? (h += '<label for="' + v + '" class="img"><img src="'+ imgsrc +'" />', h += '<img class="crossed-out" src="' + l + 'https://cdn.shopify.com/s/files/1/0008/6156/9085/t/20/assets/soldout.png" />', h += "</label>") : (h += '<label for="' + v + '">' + y, h += '<img class="crossed-out" src="' + l + 'https://cdn.shopify.com/s/files/1/0008/6156/9085/t/20/assets/soldout.png" />', h += "</label>"), h += "</div>", m.push(y))
                    }
                    h += "</div></div>";
                    quickViewHtml += h;
                  }
                }
              }
            }
            if (data.product.product_type != "Eyeglasses") {
              if (variants[0].compare_at_price > variants[0].price) {
                quickViewHtml +=
                  '<input type="hidden" id="saleitem" name="properties[saleitem]" value="1">';
              } else {
                quickViewHtml +=
                  '<input type="hidden" id="saleitem" name="notsaleiteam">';
              }
              quickViewHtml +=
                '<div class="product-form-item product-form_item-submit" data-product-options="" data-vpid="' +
                variants[0].id +
                '">';
              if (product_v_qty[0] > product_max_qty) {
                quickViewHtml +=
                  '<button type="submit" name="add" id="AddToCart-product-template" class="btn product-form__cart-submit">';
                quickViewHtml +=
                  '<span id="AddToCartText-product-template">Add to cart</span>';
              } else {
                quickViewHtml +=
                  '<button type="submit" name="add" id="AddToCart-product-template" class="btn product-form__cart-submit" disabled="disabled">';
                quickViewHtml +=
                  '<span id="AddToCartText-product-template">Sold Out</span>';
              }
              quickViewHtml += "</button>";
              quickViewHtml += "</div>";
            } else {
              quickViewHtml +=
                '<div class="sold-store product-form-item product-form_item-submit">';
              quickViewHtml +=
                '<a href="javascript:void(0);" class="AddToCart-product-template btn product-form__cart-submit">Currently Only Sold In Stores</a>';
              quickViewHtml +=
                '<span><a href="/apps/store-locator">Find A Store Nearest You</a></span>';
              quickViewHtml += "</div>";
            }

            //quickViewHtml += '<div class="qv-discount-message">'+quickViewMessage+'</div>';
            quickViewHtml += "</form>";

            quickViewHtml += "</div>";
            quickViewHtml += '<div class="product-detail-row">';
            quickViewHtml +=
              '<a href="' +
              data_url +
              '" class="product-detail__more-details">More details</a>';
            quickViewHtml += "</div>";
            quickViewHtml += "</div></div></div></div></div></div></div></div>";

            $("#myModal .modal-dialog").html(quickViewHtml);

            setTimeout(function () {
              if (data_color != "") {
                $('input[value="' + selected_variant + '"]')
                  .prop("checked", true)
                  .trigger("change");
              }
            }, 300);

            $('.swatch-element input[type="radio"]').change(function () {
              var ddt = jQuery(this).val();
              if (
                $(this)
                  .closest(".swatch")
                  .hasClass("color")
              ) {
                $(this)
                  .closest(".swatch")
                  .find(".header")
                  .html("<span>Color: </span>" + ddt);
                $(this)
                  .closest("form")
                  .find("select.product-select-qv.color")
                  .val(ddt)
                  .change();
              }
              if (
                $(this)
                  .closest(".swatch")
                  .hasClass("size")
              ) {
                $(this)
                  .closest(".swatch")
                  .find(".header")
                  .html("<span>Size: </span>" + ddt);
                $(this)
                  .closest("form")
                  .find("select.product-select-qv.size")
                  .val(ddt)
                  .change();
              }
            });

            setTimeout(function () {
              $("#divImage").css("display", "none");
            }, 1000);

            // quickview variant change
            $(".product-select-qv").change(function () {
              var variant_name =
                $("#product-select-qv-opt-0").val() +
                " / " +
                $("#product-select-qv-opt-1").val();
              $("#product-select-qv option")
                .filter(function () {
                  return $(this).text() == variant_name;
                })
                .prop("selected", true);
              $("#product-select-qv option").trigger("change");
              var c_new_price = $("#product-select-qv option:selected").attr(
                "data-cprice"
              );
              $("#myModal .modal-dialog #ProductPrice-product-template").text(
                $("#product-select-qv option:selected").attr("data-qprice")
              );
              if (c_new_price != "0") {
                $("#myModal .modal-dialog #ComparePrice-product-template").text(
                  $("#product-select-qv option:selected").attr("data-cprice")
                );
                $("#saleitem").attr("name", "properties[saleitem]");
                $("#saleitem").val(1);
              } else {
                $("#saleitem").attr("name", "notsaleiteam");
                $("#myModal .modal-dialog #ComparePrice-product-template").text(
                  ""
                );
              }
              $('#myModal .modal-dialog .product-form_item-submit').attr('data-vpid', $('#product-select-qv').val());
              if ($('#product-select-qv option:selected').text() != variant_name) {
                $('#myModal .modal-dialog .product-form_item-submit .product-form__cart-submit').attr('disabled', 'disabled');
                $('#myModal .modal-dialog #ProductPrice-product-template').css('opacity', '0');
                $('#myModal #AddToCartText-product-template').text("Unavailable");
                $('#myModal .modal-dialog .product-form_item-submit .product-form__cart-submit').attr('disabled', 'disabled');
              } else {
                $('#myModal .modal-dialog .product-form_item-submit .product-form__cart-submit').removeAttr('disabled');
                $('#myModal .modal-dialog #ProductPrice-product-template').css('opacity', '1');
                var variant_aviable = $('#product-select-qv option:selected').attr('data-available');
                if (variant_aviable == 'true') {
                  $('#myModal #AddToCartText-product-template').text("Add To Cart");
                  $('#myModal .modal-dialog .product-form_item-submit .product-form__cart-submit').removeAttr('disabled');
                } else {
                  $('#myModal #AddToCartText-product-template').text("Sold Out");
                  $('#myModal .modal-dialog .product-form_item-submit .product-form__cart-submit').attr('disabled', 'disabled');
                }
              }
              $('.quick-slider').empty().removeClass('slick-initialized').removeClass('slick-slider');
              $('.pro_slick-pager').empty().removeClass('slick-initialized').removeClass('slick-slider');
              for (var image in product.images) {
                var fstVar2 = $('#product-select-qv-opt-0').val();
                var prdImgAlt2 = product.images[image].alt;
                if (fstVar2.indexOf(prdImgAlt2) > -1) {
                  $(".quick-slider").append(
                    '<div><div class="pro_img"><img class="product_img" src="' +
                    product.images[image].src +
                    '"></div></div>'
                  );
                }
                if ($.trim(prdImgAlt2).length > 45) {
                  if (
                    prdImgAlt2.indexOf("youtube") > -1 ||
                    prdImgAlt2.indexOf("vimeo") > -1
                  ) {
                    $(".quick-slider").append(
                      '<div class="resp-container"><div class="video_wrapper"> <iframe class="resp-iframe" src="' +
                      prdImgAlt2 +
                      '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div></div>'
                    );
                  }
                }
              }

              for (var image in product.images) {
                var fstVar3 = $("#product-select-qv-opt-0").val();
                var prdImgAlt3 = product.images[image].alt;
                if (fstVar3.indexOf(prdImgAlt3) > -1) {
                  $(".pro_slick-pager").append(
                    '<div><div class="product_thumbnails"><img src="' +
                    product.images[image].src +
                    '" /></div></div>'
                  );
                }
                if ($.trim(prdImgAlt3).length > 45) {
                  if (
                    prdImgAlt3.indexOf("youtube") > -1 ||
                    prdImgAlt3.indexOf("vimeo") > -1
                  ) {
                    $(".pro_slick-pager").append(
                      '<div><div class="product_thumbnails dd-thumbslide-vdo"><img src="' +
                      product.images[image].src +
                      '" /></div></div>'
                    );
                  }
                }
              }
              $(".quick-slider").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: ".pro_slick-pager"
              });
              $(".pro_slick-pager").slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: ".quick-slider",
                dots: false,
                focusOnSelect: true
              });
            });
            $(".quick-slider").slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              fade: true,
              asNavFor: ".pro_slick-pager"
            });
            $(".pro_slick-pager").slick({
              slidesToShow: 4,
              slidesToScroll: 1,
              asNavFor: ".quick-slider",
              dots: false,
              focusOnSelect: true
            });
            $(".swatch_mob_slider").owlCarousel({
              nav: true,
              responsive: {
                0: {
                  items: 3
                },
                600: {
                  items: 4
                },
                1000: {
                  items: 4
                }
              }
            });

            $("#ddtclass input:radio").trigger("click");
            if ($(".spr-badge").length > 0) {
              $.getScript(
                window.location.protocol +
                "//productreviews.shopifycdn.com/assets/v4/spr.js"
              );
            }
            if ($(".product-form.product-form-product-template").length > 0) {
              $(".product-form.product-form-product-template").submit(function (
                e
              ) {
                e.preventDefault();
                var data_vpid = parseInt(
                  $(this)
                    .find(".product-form_item-submit")
                    .attr("data-vpid")
                );
                if ($("#saleitem").length > 0) {
                  var data_property = $("#saleitem").attr("name");
                  if (data_property == "notsaleiteam") {
                    addToCart(data_vpid, 1);
                    console.log(data_property);
                  } else {
                    addToCartattr(data_vpid, 1, data_property);
                  }
                } else {
                  addToCart(data_vpid, 1);
                }
                $("#myModal .close").click();
              });
            }
          });
        },
        error: function () {
          console.log("error");
        }
      });
    }
  });
}
$(document).on("click", ".minicart__remove.remove", function () {
  var id = $(this).attr("data-id");
  updateCartItem(id, 0, $(this));
});

// mobile menu
var wid = $(window).width();
$(document).on(
  "click",
  "#MobileNav1 > .mobile-nav_item > .mobile-nav__link",
  function () {
    var catSubUl = $(this).siblings(".sub-menu");
    if (catSubUl.is(":hidden")) {
      $("#MobileNav1 > .mobile-nav_item > .sub-menu").slideUp();
      catSubUl.slideDown();
      $("#MobileNav1 > .mobile-nav_item > .mobile-nav__link").removeClass(
        "active"
      );
      $(this).addClass("active");
    } else {
      catSubUl.slideUp();
      $(this).removeClass("active");
    }
  }
);

$(document).on(
  "click",
  "#MobileNav1 .sub-menu > .mobile-nav_item > .mobile-nav__link",
  function () {
    console.log(1234);
    var catSubUl = $(this).siblings(".sub-menu");
    if (catSubUl.is(":hidden")) {
      $("#MobileNav1 .sub-menu > .mobile-nav_item > .sub-menu").slideUp();
      catSubUl.slideDown();
      $(
        "#MobileNav1 .sub-menu > .mobile-nav_item > .mobile-nav__link"
      ).removeClass("active");
      $(this).addClass("active");
    } else {
      catSubUl.slideUp();
      $(this).removeClass("active");
    }
  }
);
// end mobile menu

var time = undefined;
$(function () {
  //init
  //   $('.msrItems').msrItems({
  //     'colums': 4, //columns number
  //     'margin': 0 //right and bottom margin
  //   });

  //   //update columns size on window resize
  //   $( window ).on('resize', function(e) {
  //     clearTimeout(time);
  //     time = setTimeout(function(){
  //       $('.msrItems').msrItems('refresh');
  //     }, 200);
  //   })

  //load new elements(without updating existing)
  //$('.msrItems').msrItems('doload', [
  //'<div class="itm8 msrItem"></div>',
  //'<div class="itm9 msrItem"></div>',
  //'<div class="itm10 msrItem"></div>'
  //]);

  $(".quick-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".pro_slick-pager"
  });
  $(".pro_slick-pager").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".quick-slider",
    dots: false,
    focusOnSelect: true
  });

  // ----- ANNOUNCEMENTS ----- //

  // Morphext link rotation
  $("#rotateAnnounce").Morphext({
    animation: "fadeIn",
    separator: "|",
    speed: 6000
  });

  $(".announcement-bar").each(function () {
    if (localStorage.getItem("hidden") == 1) {
      $(this).addClass("is--hidden");
      $("body").addClass("bar--hidden");
    } else {
      $(this).removeClass("is--hidden");
      $("body").removeClass("bar--hidden");
    }

    $(".announcement__close").on("click", function () {
      $("body").addClass("nav-opendd");
      $(this)
        .closest(".announcement-bar")
        .slideToggle();
      localStorage.setItem("hidden", 1);
      $("body").addClass("bar--hidden");
      return false;
    });
  });

  $(".newsletter__button").magnificPopup({
    type: "inline",
    preloader: false,
    modal: true
  });
  $(document).on("click", ".newsletter-popup__close-x", function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });
});

// ----- HOME NEWSLETTER POPUP ----- //
// $(window).load(function() {
//   setTimeout(function() {
//     if ($(".hide_popup_mobile").length > 0) {
//       if ($(window).width() > 768) {
//         if ($(".template-index").length > 0) {
//           if (localStorage.getItem("newsletter-popup") != 1) {
//             $(".newsletter__button.popup-modal").trigger("click");
//           }
//           $("#newsletter-modal .newsletter-popup__close-x").on(
//             "click",
//             function() {
//               localStorage.setItem("newsletter-popup", 1);
//             }
//           );
//         }
//       }
//     } else {
//       if ($(".template-index").length > 0) {
//         if (localStorage.getItem("newsletter-popup") != 1) {
//           $(".newsletter__button.popup-modal").trigger("click");
//         }
//         $("#newsletter-modal .newsletter-popup__close-x").on(
//           "click",
//           function() {
//             localStorage.setItem("newsletter-popup", 1);
//           }
//         );
//       }
//     }

//     $(".ql-snow a").on("click", function(e) {
//       e.preventDefault();
//       $.magnificPopup.close();
//     });
//   }, 1000);
// });

/*
 if (localStorage.getItem("threedaytimestemp") === null) {

 }else{
   var todaytimeStamp = Math.floor(Date.now());
  var aftertday = localStorage.getItem("threedaytimestemp");
  if (aftertday > todaytimeStamp)
  {
    console.log(todaytimeStamp);
    console.log(aftertday);
    $('.newsletter-popup-content-form').hide();
   $('.newsletter-popup__close').hide();
   $('.newsletter-popup-content-success').show();
   $('.newsletter__button.popup-modal').trigger('click');
  }
 }*/
$(document).on("click", ".rotate-images__switch", function () {
  $(".rotate-images__switch").removeClass("rotate-images__switch--active");
  $(this).addClass("rotate-images__switch--active");
  var alts = $(this).attr("data-toggle-alts");
  $(".grid--uniform.grid--view-items .grid__item").each(function () {
    console.log(
      $(this).find('.product-tile__image-wrap img[data-ind="' + alts + '"]')
        .length
    );
    $(this)
      .find(".product-tile__image-wrap img")
      .hide();
    $(this)
      .find('.product-tile__image-wrap img[data-ind="' + alts + '"]')
      .show();
  });
});

$(document).ready(function () {
  if ($(".generic-page").length > 0) {
    var container = $(".generic-copy"),
      header = $(".generic-copy .faq_title");

    container.append("<hr>");
    //     header.append('<span class="faq-btn" data-faq-btn></span>');

    header.on("click", function () {
      $(this)
        .toggleClass("open")
        .next()
        .slideToggle();
    });
  }

  /*-- Added UK@DD --*/
  $(document).on("click", ".qtyplus", function (e) {
    e.preventDefault();

    var $this = $(this),
      $input = $this.prev("input"),
      newValue = parseInt($input.val()) + 1;
    $input.val(newValue);
    $(this)
      .parents(".cart__qty")
      .siblings(".cart__update")
      .trigger("click");
  });

  $(document).on("click", ".qtyminus", function (e) {
    e.preventDefault();

    var $this = $(this),
      $input = $this.next("input"),
      newValue = parseInt($input.val()) - 1;

    if (newValue < 1) {
      $input.val(1);
    } else {
      $input.val(newValue);
      $(this)
        .parents(".cart__qty")
        .siblings(".cart__update")
        .trigger("click");
    }
  });

  $(document).on("click", ".filter__toggle", function () {
    $(this).toggleClass("active");
    $(this)
      .closest(".filters__group")
      .find("div.filters")
      .toggle(100);
  });

  //   if($(window).width() > 1023){
  //     $('ul.advanced-filters').each(function(){
  //       var LiN = $(this).find('li').length;
  //       if($(this).find('li.active-filter').length){

  //       }
  //       else{
  //         if( LiN > 5){
  //           $('li', this).eq(4).nextAll().hide().addClass('toggleable');
  //           $(this).append('<li class="more"><span class="filters-view__text filters-view__text--more">View More<span class="nav__icon icon--plus"></span></span></li>');
  //         }
  //       }

  //     });

  //     $('ul.advanced-filters').on('click','.more', function(){
  //       if( $(this).hasClass('less') ){
  //         $(this).html('<span class="filters-view__text filters-view__text--more">View More<span class="nav__icon icon--plus"></span></span>').removeClass('less');
  //       }else{
  //         $(this).html('<span class="filters-view__text filters-view__text--less">View Less<span class="nav__icon icon--minus"></span></span>').addClass('less');
  //       }
  //       $(this).siblings('li.toggleable').slideToggle();
  //     });
  //   }

  if ($(window).width() < 1024) {
    $(".men-women-cols .grid--view-items").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    /*-- Footer Accordian --*/
    $(document).on("click", ".footer-nav__icon", function () {
      if (!$(this).hasClass("storelocator")) {
        if (
          !$(this)
            .closest(".h2")
            .hasClass("active")
        ) {
          $(".site-footer .grid__ftr-widget .footer-nav__links").slideUp();
          $(".site-footer .h2").removeClass("active");
          $(this)
            .closest(".grid__ftr-widget")
            .find(".footer-nav__links")
            .slideDown();
          $(this)
            .closest(".h2")
            .addClass("active");
        } else {
          $(".site-footer .grid__ftr-widget .footer-nav__links").slideUp();
          $(".site-footer .h2").removeClass("active");
        }
      }
    });

    $(document).on("click", ".support-filter__title", function () {
      $(this).toggleClass("active");
      $(this)
        .closest(".support-filter")
        .find(".support-filter-dropdown")
        .slideToggle();
    });

    /*-- Product Accordian --*/
    $(document).on("click", ".product-detail-tabs-content__nav", function () {
      var det_tab = $(this).attr("data-product-detail-tab");

      if (
        !$(this)
          .find(".product-detail-tabs-nav__title")
          .hasClass("active")
      ) {
        $(".product-detail-tabs-content__item").slideUp();
        $(".product-detail-tabs-nav__title").removeClass("active");
        $(this)
          .next(".product-detail-tabs-content__item")
          .slideDown();
        $(this)
          .find(".product-detail-tabs-nav__title")
          .addClass("active");
      } else {
        $(".product-detail-tabs-content__item").slideUp();
        $(".product-detail-tabs-nav__title").removeClass("active");
      }

      /* if(det_tab == 2){
        if ($('.product-detail-tabs-slider__list').hasClass('slick-initialized')) {
          $('.product-detail-tabs-slider__list').slick('unslick');
          $('.product-detail-tabs-slider__list').slick(fitGuideSlider);
        }
      }       */
    });

    $(".dd-first-polarize").removeClass("active");

    $(document).on(
      "click",
      ".story-top-nav--mobile .story-top-nav__menu",
      function () {
        $(this).toggleClass("active-toggle");
        $(this)
          .closest(".story-top-nav--mobile")
          .find("ul.story-top-nav__list")
          .slideToggle();
      }
    );
  }

  /*if($('.dd_size .swatch-element').length < 2){
  	$('.dd_size').hide();
    $('.product-detail-options-size').hide();
  }*/
});

$(function () {
  var filters = $(".advanced-filter"),
    el,
    elGroup,
    elHandle,
    activeTagInGroup;

  filters.on("click", function (e) {
    el = $(this);
    elGroup = el.data("group");
    elHandle = el.data("handle");
    activeTagInGroup = $('.active-filter[data-group="' + elGroup + '"]');
    // If the tag clicked is not already active and its group contains an active tag, we will swap tag within the group.
    if (!el.hasClass("active-filter") && activeTagInGroup.size()) {
      e.preventDefault();
      location.href = location.href
        // swap tag
        .replace(activeTagInGroup.data("handle"), elHandle)
        // go back to page 1
        .replace(/(&page=\d+)|(page=\d+&)|(\?page=\d+$)/, "");
    }
  });
});

/* ----- SCROLLING UP/DOWN HTML CLASS ----- */
var lastScrollTop = 0;
var setScrollDirection = function () {
  // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (scrollTop > lastScrollTop) {
    // downscroll code
    $("html").addClass("scrolling--down");
    $("html").removeClass("scrolling--up");
  } else {
    // upscroll code
    $("html").addClass("scrolling--up");
    $("html").removeClass("scrolling--down");
  }

  lastScrollTop = scrollTop;
};

window.addEventListener(
  "scroll",
  function () {
    requestAnimationFrame(function () {
      setScrollDirection();
    });
  },
  false
);

var pathname = window.location.pathname;

// $('a.header-nav__link[href="'+pathname+'"]').addClass('active');
$('a.nav-lookbook[href="' + pathname + '"]').addClass("active");

if ($('a.header-nav__link[href="' + pathname + '"]').length < 2) {
  $('a.header-nav__link[href="' + pathname + '"]')
    .parents(".nav-dropdown_mega")
    .find(".site-nav__link--main")
    .addClass("active");
}
$('a.nav-lookbook[href="' + pathname + '"]')
  .parents(".nav-dropdown_mega")
  .find(".site-nav__link--main")
  .addClass("active");

if (pathname == "/apps/store-locator") {
  $(document).prop("title", "Store Locator | RAEN");

  $(document).on(
    "click",
    "#store_locator_title, .stores-locator__close",
    function () {
      $(".online-retailers-main").hide();
      $(".search_bar, #store_map, #addresses_list").show();
      $("#store_locator_title").addClass("active");
      $("#online_retailers_title").removeClass("active");
    }
  );

  $(document).on("click", "#online_retailers_title", function () {
    $(".online-retailers-main").show();
    $(".search_bar, #store_map, #addresses_list").hide();
    $("#store_locator_title").removeClass("active");
    $("#online_retailers_title").addClass("active");
  });

  $(".search_filters .search_filter").each(function () {
    var lable_id = $(this)
      .find("input")
      .attr("id");
    $(this.lastChild).wrap('<label for="' + lable_id + '"></label>');
  });
}

$(document).on("click", ".filters__title--mobile", function () {
  $(".collection-wrap").addClass("filters--active");
});

$(document).on("click", ".collection-wrap .filters__toggle", function () {
  $(".collection-wrap").removeClass("filters--active");
});

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

$(function() {
  if ($('.account-menu').length > 0) { 
    
    // TODO: Consider refactoring Phils Regex function above to use this.
    grabTabParam = function (tabParam) {
      var paramResults = new RegExp('[\?&]' + tabParam + '=([^&#]*)').exec(window.location.search);
      return (paramResults !== null) ? paramResults[1] || 0 : false;
    }

    var tab_acc = getParameterByName("tab");
    
    if (tab_acc == "account") {
      $(".tab_account").show();
      $(".tab_order_history").hide();
      $(".generic-filter__link--profile").addClass("active");
      $(".generic-filter__link--orderhistory").removeClass("active");
    } else if (tab_acc == "order-history") {
      $(".tab_order_history").show();
      $(".tab_account").hide();
      $(".generic-filter__link--orderhistory").addClass("active");
      $(".generic-filter__link--profile").removeClass("active");
    }
  }
});


$(".fabrique-gallery").slick({
  dots: false,
  infinite: true,
  speed: 700,
  slidesToShow: 1,
  slidesToScroll: 1
});

// ----- FIXED HEADER ----- //
$("[data-header]").each(function () {
  var announcement = $(".announcement-bar.announcement-bar--link"),
    announcementHeight = 0,
    header = $(".header-section"),
    headerHeight = 0,
    headerTop = 0,
    documentHeight = 0,
    minWidth = header.data("stickyheader-min-width"),
    offsetHeight = 0,
    usertools = $(".usertools"),
    usertoolsHeight = 0,
    windowHeight = 0,
    windowScrollCurrent = 0,
    windowScrollBefore = 0,
    windowScrollDiff = 0;

  $(window).on("scroll", function () {
    if ($(window).width() > minWidth) {
      announcementHeight =
        typeof announcement !== "undefined" &&
          !announcement.hasClass("is--hidden")
          ? announcement.outerHeight()
          : 0;
      headerHeight = header.height();
      documentHeight = $(document).height();
      usertoolsHeight =
        typeof usertools !== "undefined" ? usertools.height() : 0;
      windowHeight = $(window).height();
      windowScrollCurrent = $(window).scrollTop();
      windowScrollDiff = windowScrollBefore - windowScrollCurrent;
      headerTop = parseInt(header.css("top")) + windowScrollDiff;
      offsetHeight = announcementHeight + usertoolsHeight;

      if (windowScrollCurrent <= 0) {
        // When scrolled to the very top the header sticks to the top
        header.css("top", 0);
        header.css("marginTop", 0);
      } else if (windowScrollDiff > 0) {
        // When scrolled up the header slides in
        headerTop = headerTop > 0 ? 0 : headerTop;

        if (headerTop <= -offsetHeight && windowScrollCurrent > headerHeight) {
          header.css("marginTop", -offsetHeight);
        }

        if (windowScrollCurrent <= offsetHeight && headerTop >= 0) {
          header.css(
            "marginTop",
            -(offsetHeight - Math.abs(windowScrollCurrent - offsetHeight))
          );
        }

        header.css("top", headerTop);
      } else if (windowScrollDiff < 0) {
        // When scrolled down
        header.css(
          "top",
          Math.abs(headerTop) > headerHeight ? -headerHeight : headerTop
        );
      }

      windowScrollBefore = windowScrollCurrent;
    }
  });

  $(window)
    .on("load resize", function () {
      if ($(window).width() > minWidth) {
        $("body").css({ "padding-top": header.height() });
      } else {
        $("body").css({ "padding-top": "" });
        header.css("top", "");
      }
    })
    .resize();

  $("[data-remove-announcement]").on("click", function () {
    if ($(window).width() > minWidth) {
      var close = setInterval(function () {
        $("body").css({ "padding-top": header.height() });
      }, 10);

      setTimeout(function () {
        $("body").css({ "padding-top": header.height() });
        clearInterval(close);
      }, 500);
    }
  });
});

$(window).load(function () {
  var pathname1 = location.hash;
  if (pathname1 == "#review") {
    $(".review_link").trigger("click");
  }
});
$(document).ready(function () {
  $('a[href^="/account/logout"]').on("click", function () {
    $.ajax($(this).attr("href")).done(function () {
      window.location.href = "/account";
    });
    return false;
  });

  $(window).bind("scroll", function () {
    if ($(window).width() < 767 && $(window).scrollTop() > 100) {
      $(".mobile-sticky").addClass("cart-checkoutfixed");
    } else {
      $(".mobile-sticky").removeClass("cart-checkoutfixed");
    }
  });
});

var scrollTarget = function (target) {
  if (target.length) {
    var offset = 0;

    if (target == "who-we-are") {
      if ($(window).width() < 1024) {
        offset = 60;
      } else {
        offset = -130;
      }
    }

    if (target == "our-process") {
      if ($(window).width() < 1024) {
        offset = 120;
      } else {
        offset = 50;
      }
    }

    if (target == "where-we-are") {
      if ($(window).width() < 1024) {
        offset = 120;
      } else {
        offset = -40;
      }
    }

    if (target == "work-for-us") {
      if ($(window).width() < 1024) {
        offset = 90;
      } else {
        offset = -15;
      }
    }

    if ((target = !"myModal")) {
      $("html, body").animate(
        {
          scrollTop: $("#" + target).offset().top - offset
        },
        750
      );
    }
  }
};

var hash = window.location.hash.substr(1);

if (hash) {
  window.scrollTo(0, 0);

  $(window).on("load", function () {
    // scrollTarget(hash);
  });
}

$("[data-scroll]").on("click", function () {
  // scrollTarget($(this).attr('href').substr(1));
  return false;
});

$(".register form").submit(function () {
  if ($("#CreatePassword").val().length < 8) {
    $(".password small").addClass("focuss");
  } else {
    $(".password small").removeClass("focuss");
  }

  if ($('input[name="user-terms"]').is(":checked")) {
    $(".terms").removeClass("focusd");
    return true;
  } else {
    alert("You must agree to the terms and conditions!");
    $(".terms").addClass("focusd");
    return false;
  }

  return false;
});

if ($(window).width() < 768) {
  $(".mantle-collection__button").on("click", function () {
    var button = $(this),
      container = button.parents(".mantle-description");
    container.toggleClass("active");
  });

  //   $('.swatch.dd_color .swatch_mob_slider').slick({
  //     slidesToShow: 3,
  //     loop:false,
  //     slidesToScroll: 2,
  //     arrows: false,
  //     dots: false
  //   });
}

if ($(".template-product").length > 0) {
  $(document.documentElement).keyup(function (e) {
    if (e.keyCode == 39) {
      $(".featuredPostSlider.slick-slider .slick-arrow.slick-next").trigger(
        "click"
      );
    }
    if (e.keyCode == 37) {
      $(".featuredPostSlider.slick-slider .slick-arrow.slick-prev").trigger(
        "click"
      );
    }
  });
}

var html5lightbox_options = {
  overlaybgcolor: "#fff",
  overlayopacity: "1",
  fullscreenmode: "true",
  alwaysshownavarrows: "true",
  titleprefix: " ",
  imagepercentage: 100,
  titlecss:
    "color:#000; font-size:16px;font-family: 'Libre Baskerville', serif;",
  descriptioncss: "color:red;",
  titleinsidecss: "color:blue;",
  descriptioninsidecss: "color:green;"
};

// $(".lookbook-detail-gallery").click(function() {
//   $('html, body').animate({
//     scrollTop: $(".lookbook-detail-product").offset().top
//   }, 1000);
// });

$(document).ready(function () {
  if ($(".template-collection").length > 0) {
    var pathnamedd = location.pathname;
    var divistion = pathnamedd.split("/");
    var col_ID = $(".collection-wrap").data("colid");
    var col_url = $(".collection-wrap").data("url");
    //the unisex page had a location.pathname.length == 3, so the ajax function wasn't running.
    //Specifically added in an exception for the unisex-sale page, just in case there was a particular
    //reason for the original condition being divisition.length > 3
    //see more detail in commit message/pull request
    if (divistion[divistion.length - 1] == "unisex-sale") {
      $(
        '<p class="discount_sale">*Discount codes cannot be applied to sale items*</p>'
      ).insertBefore(".dd-filter-data");
    }

    if (divistion.length > 3) {
      var urlhandle = pathnamedd.substr(pathnamedd.lastIndexOf("/") + 1);
      if (urlhandle.length > 1) {
        $(".maincategory1 a").attr(
          "href",
          $(".maincategory1").attr("data-handle") + "/" + urlhandle
        );
        $(".maincategory2 a").attr(
          "href",
          $(".maincategory2").attr("data-handle") + "/" + urlhandle
        );

        var valNew = urlhandle.split("+");
        var colorgroup = "";
        var face_fit = "";
        var face_shape = "";
        var frame_finish = "";
        var frame_shape = "";
        var gender = "";
        var lens_color = "";
        var lens_treatment = "";
        var lens_material = "";
        var polarized = "";
        var filterby = "";
        var sortby = "";
        var stock_limit = parseInt(
          $(".page-container").attr("data_out_of_stock")
        );
        for (var i = 0; i < valNew.length; i++) {
          if (valNew[i].indexOf("colorgroup") > -1) {
            colorgroup += valNew[i];
            if (i != valNew.length - 1) {
              colorgroup += ",";
            }
          }
          if (valNew[i].indexOf("fit") > -1) {
            face_fit += valNew[i];
            if (i != valNew.length - 1) {
              face_fit += ",";
            }
          }

          if (valNew[i].indexOf("face-shape") > -1) {
            face_shape += valNew[i].replace("face-shape", "face shape");
            //face_shape += valNew[i];
            if (i != valNew.length - 1) {
              face_shape += ",";
            }
          }

          if (valNew[i].indexOf("frame-finish") > -1) {
            frame_finish += valNew[i].replace("frame-finish", "frame finish");
            //frame_finish += valNew[i];
            if (i != valNew.length - 1) {
              frame_finish += ",";
            }
          }

          if (valNew[i].indexOf("frame-shape") > -1) {
            frame_shape += valNew[i].replace("frame-shape", "frame shape");
            //frame_shape += valNew[i];
            if (i != valNew.length - 1) {
              frame_shape += ",";
            }
          }

          if (valNew[i].indexOf("gender") > -1) {
            gender += valNew[i];
            if (i != valNew.length - 1) {
              gender += ",";
            }
          }

          if (valNew[i].indexOf("lens-color") > -1) {
            lens_color += valNew[i].replace("lens-color", "lens color");
            //lens_color += valNew[i];
            if (i != valNew.length - 1) {
              lens_color += ",";
            }
          }

          if (valNew[i].indexOf("lens-treatment") > -1) {
            lens_treatment += valNew[i].replace(
              "lens-treatment",
              "lens treatment"
            );
            //lens_treatment += valNew[i];
            if (i != valNew.length - 1) {
              lens_treatment += ",";
            }
          }

          if (valNew[i].indexOf("material") > -1) {
            lens_material += valNew[i];
            if (i != valNew.length - 1) {
              lens_material += ",";
            }
          }

          if (valNew[i].indexOf("polarized") > -1) {
            polarized += valNew[i];
            if (i != valNew.length - 1) {
              polarized += ",";
            }
          }

          if (valNew[i].indexOf("filter") > -1) {
            filterby += valNew[i].replace("filter-by", "filter by");
            if (i != valNew.length - 1) {
              filterby += ",";
            }
          }

          if (valNew[i].indexOf("sort-by") > -1) {
            var sort_val = valNew[i];
            $(".sortby__link[href='" + sort_val + "']").addClass(
              "sortby__link--active"
            );
            $("h3.sortby__title").text(
              $(".sortby__link[href='" + sort_val + "']").text()
            );

            sortby = valNew[i].replace("sort-by_", "");
          }
        }

        //       $('.maincategory1 a').attr('href',$('.maincategory1').attr('data-handle')+'/'+added_newurl);
        //       $('.maincategory2 a').attr('href',$('.maincategory2').attr('data-handle')+'/'+added_newurl);

        var data = {};
        data["collection"] = col_ID;
        data["collection_url"] = col_url;
        data["colorgroup"] = colorgroup;
        data["face_fit"] = face_fit;
        data["face_shape"] = face_shape;
        data["frame_finish"] = frame_finish;
        data["frame_shape"] = frame_shape;
        data["gender"] = gender;
        data["lens_color"] = lens_color;
        data["lens_treatment"] = lens_treatment;
        data["lens_material"] = lens_material;
        //data['polarized'] = polarized;
        data["polarized"] = "";
        data["filterby"] = filterby;
        data["sort_by"] = sortby;
        data["stock_limit"] = stock_limit;

        var myJSON = JSON.stringify(data);

        var params = {
          type: "POST",
          //         url: 'https://cobs.goofyfaces.com/filter/product.php',
          url: "https://script.raen.com/php/filter/product.php",
          data: myJSON,
          // data: '{"collection":36315398205,"tags":"Polarized_Polarized,Colorgroup_Black,Colorgroup_Brown","colorgroup":"Colorgroup_Black,Colorgroup_Brown"}',
          success: function (data) {
            //console.log(""+data);
            if (data == "Sorry, there are no products in this collection") {
              window.location.href = col_url;
            } else {
              console.log("this ran");
              $(".dd-filter-data").html(data);
              if (window.location.pathname.indexOf("sale") > -1) {
                $(
                  '<p class="discount_sale">*Discount codes cannot be applied to sale items*</p>'
                ).insertBefore(".dd-filter-data");
              } else {
                $(".discount_sale").remove();
              }
              filterloaded();
            }
            /*
          if (data) {
            $('.dd-filter-data').html(data);
            filterloaded();
          } else {
            var nullHtml = '<div class="grid__item small--text-center"><p class="text-center">Sorry, there are no products in this collection</p></div>';
            $('.dd-filter-data').html(nullHtml);
          }
          */
          },
          error: function (XMLHttpRequest, textStatus) {
            Shopify.api.onError(XMLHttpRequest, textStatus);
          }
        };
        $.ajax(params);
        return false;
      }
    }
  }
});

$(document).on("click", ".aply_filter", function () {
  $(".dd-mobiles span").trigger("click");
});

$(document).on(
  "click",
  ".grouduk_filter .advanced-filter a, .sortby__item a.sortby__link",
  function () {
    $("#filter-add-class")
      .removeClass()
      .addClass("php-filter");
    $(".dd-filter-data").empty();
    var pathnamedd = location.pathname;
    var divistion = pathnamedd.split("/");
    var hrefdd = $(this).attr("href");
    var newurl = "";

    //if(hrefdd.indexOf('sort-by_') > -1){
    var lastindexd = pathnamedd.substr(pathnamedd.lastIndexOf("/") + 1);
    var sortval = lastindexd.split("+");
    for (var k = 0; k < sortval.length; k++) {
      if (sortval[k].indexOf("sort-by_") > -1) {
        sortval[k] = hrefdd;
      }
    }
    sortval = sortval.join("+");
    //}

    if (
      $(this)
        .closest("li.advanced-filter")
        .hasClass("active-filter")
    ) {
      if (divistion.length > 3) {
        if (divistion[3].indexOf("+") > -1) {
          if (divistion[3].indexOf(hrefdd) == 0) {
            var urlremove = pathnamedd.replace(hrefdd + "+", "");
          } else {
            var urlremove = pathnamedd.replace("+" + hrefdd, "");
          }
        } else {
          var urlremove = pathnamedd.replace("/" + hrefdd, "");
        }
      } else {
        var urlremove = pathnamedd.replace("/" + hrefdd, "");
      }
      $(this)
        .closest("li.advanced-filter")
        .removeClass("active-filter");

      if (history.pushState) {
        newurl =
          window.location.protocol + "//" + window.location.host + urlremove;

        var added_newurl = newurl.substr(newurl.lastIndexOf("/") + 1);
        $(".maincategory1 a").attr(
          "href",
          $(".maincategory1").attr("data-handle") + "/" + added_newurl
        );
        $(".maincategory2 a").attr(
          "href",
          $(".maincategory2").attr("data-handle") + "/" + added_newurl
        );

        window.history.pushState({ path: newurl }, "", newurl);
      }
    } else {
      if (hrefdd.indexOf("sort-by_") > -1) {
        if (pathnamedd.indexOf("sort-by_") > -1) {
          var ddindexdd = window.location.pathname.replace(lastindexd, sortval);
          newurl =
            window.location.protocol + "//" + window.location.host + ddindexdd;

          var added_newurl = newurl.substr(newurl.lastIndexOf("/") + 1);
          $(".maincategory1 a").attr(
            "href",
            $(".maincategory1").attr("data-handle") + "/" + added_newurl
          );
          $(".maincategory2 a").attr(
            "href",
            $(".maincategory2").attr("data-handle") + "/" + added_newurl
          );

          window.history.pushState({ path: newurl }, "", newurl);
        } else {
          if (history.pushState) {
            if (divistion.length > 3) {
              newurl =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                "+" +
                hrefdd;
            } else {
              newurl =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                "/" +
                hrefdd;
            }
            var added_newurl = newurl.substr(newurl.lastIndexOf("/") + 1);
            $(".maincategory1 a").attr(
              "href",
              $(".maincategory1").attr("data-handle") + "/" + added_newurl
            );
            $(".maincategory2 a").attr(
              "href",
              $(".maincategory2").attr("data-handle") + "/" + added_newurl
            );

            window.history.pushState({ path: newurl }, "", newurl);
          }
        }
      } else {
        $(this)
          .closest("li.advanced-filter")
          .addClass("active-filter");
        if (history.pushState) {
          if (divistion.length > 3) {
            newurl =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname +
              "+" +
              hrefdd;
          } else {
            newurl =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname +
              "/" +
              hrefdd;
          }
          var added_newurl = newurl.substr(newurl.lastIndexOf("/") + 1);
          $(".maincategory1 a").attr(
            "href",
            $(".maincategory1").attr("data-handle") + "/" + added_newurl
          );
          $(".maincategory2 a").attr(
            "href",
            $(".maincategory2").attr("data-handle") + "/" + added_newurl
          );
          window.history.pushState({ path: newurl }, "", newurl);
        }
      }
    }

    var col_ID = $(this)
      .closest(".collection-wrap")
      .data("colid");
    var col_url = $(this)
      .closest(".collection-wrap")
      .data("url");

    //var urlhandle = this.href.substr(this.href.lastIndexOf('/') + 1);
    var urlhandle = newurl.substr(newurl.lastIndexOf("/") + 1);
    var valNew = urlhandle.split("+");
    var colorgroup = "";
    var face_fit = "";
    var face_shape = "";
    var frame_finish = "";
    var frame_shape = "";
    var gender = "";
    var lens_color = "";
    var lens_treatment = "";
    var lens_material = "";
    var polarized = "";
    var filterby = "";
    var sortby = "";
    var stock_limit = parseInt($(".page-container").attr("data_out_of_stock"));

    for (var i = 0; i < valNew.length; i++) {
      if (valNew[i].indexOf("colorgroup") > -1) {
        colorgroup += valNew[i];
        if (i != valNew.length - 1) {
          colorgroup += ",";
        }
      }
      if (valNew[i].indexOf("fit") > -1) {
        face_fit += valNew[i];
        if (i != valNew.length - 1) {
          face_fit += ",";
        }
      }

      if (valNew[i].indexOf("face-shape") > -1) {
        face_shape += valNew[i].replace("face-shape", "face shape");
        //face_shape += valNew[i];
        if (i != valNew.length - 1) {
          face_shape += ",";
        }
      }

      if (valNew[i].indexOf("frame-finish") > -1) {
        frame_finish += valNew[i].replace("frame-finish", "frame finish");
        //frame_finish += valNew[i];
        if (i != valNew.length - 1) {
          frame_finish += ",";
        }
      }

      if (valNew[i].indexOf("frame-shape") > -1) {
        frame_shape += valNew[i].replace("frame-shape", "frame shape");
        //frame_shape += valNew[i];
        if (i != valNew.length - 1) {
          frame_shape += ",";
        }
      }

      if (valNew[i].indexOf("gender") > -1) {
        gender += valNew[i];
        if (i != valNew.length - 1) {
          gender += ",";
        }
      }

      if (valNew[i].indexOf("lens-color") > -1) {
        lens_color += valNew[i].replace("lens-color", "lens color");
        //lens_color += valNew[i];
        if (i != valNew.length - 1) {
          lens_color += ",";
        }
      }

      if (valNew[i].indexOf("lens-treatment") > -1) {
        lens_treatment += valNew[i].replace("lens-treatment", "lens treatment");
        //lens_treatment += valNew[i];
        if (i != valNew.length - 1) {
          lens_treatment += ",";
        }
      }

      if (valNew[i].indexOf("material") > -1) {
        lens_material += valNew[i];
        if (i != valNew.length - 1) {
          lens_material += ",";
        }
      }

      if (valNew[i].indexOf("polarized") > -1) {
        polarized += valNew[i];
        if (i != valNew.length - 1) {
          polarized += ",";
        }
      }

      if (valNew[i].indexOf("filter") > -1) {
        filterby += valNew[i].replace("filter-by", "filter by");
        if (i != valNew.length - 1) {
          filterby += ",";
        }
      }

      if (valNew[i].indexOf("sort-by") > -1) {
        var sort_val = valNew[i];
        $(".sortby__link").removeClass("sortby__link--active");
        $(".sortby__link[href='" + sort_val + "']").addClass(
          "sortby__link--active"
        );
        $("h3.sortby__title").text(
          $(".sortby__link[href='" + sort_val + "']").text()
        );

        sortby = valNew[i].replace("sort-by_", "");
      }
    }

    var data = {};
    data["collection"] = col_ID;
    data["collection_url"] = col_url;
    data["colorgroup"] = colorgroup;
    data["face_fit"] = face_fit;
    data["face_shape"] = face_shape;
    data["frame_finish"] = frame_finish;
    data["frame_shape"] = frame_shape;
    data["gender"] = gender;
    data["lens_color"] = lens_color;
    data["lens_treatment"] = lens_treatment;
    data["lens_material"] = lens_material;
    data["polarized"] = "";
    data["filterby"] = filterby;
    data["sort_by"] = sortby;
    data["stock_limit"] = stock_limit;
    var myJSON = JSON.stringify(data);

    var params = {
      type: "POST",
      //     url: 'https://cobs.goofyfaces.com/filter/product.php',
      url: "https://script.raen.com/php/filter/product.php",
      data: myJSON,
      // data: '{"collection":36315398205,"tags":"Polarized_Polarized,Colorgroup_Black,Colorgroup_Brown","colorgroup":"Colorgroup_Black,Colorgroup_Brown"}',
      success: function (data) {
        if (data) {
          $(".dd-filter-data").html(data);
          if (window.location.pathname.indexOf("sale") > -1) {
            $(".discount_sale").replaceWith(
              '<p class="discount_sale">*Discount codes cannot be applied to sale items*</p>'
            );
          } else {
            $(".discount_sale").remove();
          }

          filterloaded();
        } else {
          var nullHtml =
            '<div class="grid__item small--text-center"><p class="text-center">Sorry, there are no products in this collection</p></div>';
          $(".dd-filter-data").html(nullHtml);
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        Shopify.api.onError(XMLHttpRequest, textStatus);
      }
    };
    $.ajax(params);
    return false;
  }
);

$(theme.init);

function filterloaded() {
  $(".product-tile__quickview").magnificPopup({
    type: "inline",
    preloader: false,
    //   modal: true,
    closeOnBgClick: true,
    enableEscapeKey: true
  });

  $(document).on("click", ".product-tile__quickview", function () {
    var handle = $(this).attr("data-handle");
    var c_price = 0;
    var data_url = $(this).attr("data-url");
    var v_id = $(this).attr("data-vid");
    var data_metafield = $(this).attr("data-metafield");
    var mainImage = "";
    var product_v_qty = $(this)
      .attr("datav_qty")
      .split(",");
    var product_v_hide = $(this)
      .attr("data-hide")
      .split(",");
    var product_max_qty = parseInt($(this).attr("datamax_qty"));
    var selected_variant = $(this).attr("data-first-variant");
    var data_color = $(this).attr("data-color");
    var data_avlcolor = [];
    var numbersArray = data_color.split(",");
    $.each(numbersArray, function (index, value) {
      data_avlcolor[index] = value;
    });
    var total_color = numbersArray.length;
    $("#myModal .modal-dialog").empty();
    $.ajax({
      url: "/products/" + handle + ".js",
      dataType: "json",
      type: "GET",
      success: function (product) {
        var productData = product;
        $.ajax({
          url: "/products/" + handle + ".json"
        }).done(function (data) {
          productData.images = data.product.images;
          var quickViewHtml = "";
          var variant = "";
          var variants = product.variants;
          var firstVariant = variants[0];
          var prd_opt = product.options[0];
          var nub_color = parseInt(prd_opt.values.length);
          mainImage = product.featured_image;

          quickViewHtml += '<div class="modal-content">';
          quickViewHtml += '<div class="modal-header">';
          quickViewHtml +=
            '<button type="button" class="close popup-modal-dismiss icon--cancel"></button>';
          quickViewHtml += "</div>";
          quickViewHtml += '<div class="modal-body">';
          quickViewHtml += '<div class="product-template__container">';
          quickViewHtml += '<div class="grid grid--no-gutters">';
          quickViewHtml +=
            '<div id="divImage" class="product_modal_loader" style="display: block"><img alt="Loading... Please wait!" src="//cdn.shopify.com/s/files/1/0008/6156/9085/t/65/assets/loading.gif" width="100" height="100" /></div>';
          quickViewHtml +=
            '<div class="grid__item product-single__photos medium-up--two-thirds">';
          quickViewHtml += '<div class="quick-slider">';

          for (var image in productData.images) {
            var fstVar = firstVariant.title;
            var prdImgAlt = productData.images[image].alt;
            if (fstVar.indexOf(prdImgAlt) > -1) {
              quickViewHtml +=
                '<div><div class="pro_img"><img class="product_img" src="' +
                productData.images[image].src +
                '"></div></div>';
            }
            if ($.trim(prdImgAlt).length > 45) {
              if (
                prdImgAlt.indexOf("youtube") > -1 ||
                prdImgAlt.indexOf("vimeo") > -1
              ) {
                quickViewHtml +=
                  '<div class="resp-container"><div class="video_wrapper"> <iframe class="resp-iframe" src="' +
                  prdImgAlt +
                  '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div></div>';
              }
            }
          }
          quickViewHtml += "</div>";

          quickViewHtml += '<div class="pro_slick-pager">';
          for (var image in productData.images) {
            var fstVar1 = firstVariant.title;
            var prdImgAlt1 = productData.images[image].alt;
            if (fstVar1.indexOf(prdImgAlt1) > -1) {
              quickViewHtml +=
                '<div><div class="product_thumbnails"><img src="' +
                productData.images[image].src +
                '" /></div></div>';
            }
            if ($.trim(prdImgAlt1).length > 45) {
              if (
                prdImgAlt1.indexOf("youtube") > -1 ||
                prdImgAlt1.indexOf("vimeo") > -1
              ) {
                quickViewHtml +=
                  '<div><div class="product_thumbnails dd-thumbslide-vdo"><img src="' +
                  productData.images[image].src +
                  '" /></div></div>';
              }
            }
          }

          quickViewHtml += "</div></div>";

          quickViewHtml +=
            '<div class="grid__item product-detail-info medium-up--one-third">';
          quickViewHtml += '<div class="product-single__meta">';
          quickViewHtml +=
            '<h1 class="product-single__title">' + product.title + "</h1>";
          //       quickViewHtml += '<h3 class="product-detail__type">' + product.type +'</h3>';
          quickViewHtml +=
            '<div class="product-detail__summary summary grid-view-item">';
          quickViewHtml +=
            '<div class="product-shortdesc">' + data_metafield + "</div>";
          quickViewHtml +=
            '<a href="/products/' +
            handle +
            '#stamped-main-widgetnew"><span class="shopify-product-reviews-badge spr-badge" data-id="' +
            productData.id +
            '"></span></a>';
          quickViewHtml +=
            '<p class="product-single__price product-single__price-product-template">';
          if (data.product.product_type != "Eyeglasses") {
            quickViewHtml +=
              '<span class="product-price__price product-price__price-product-template">';
            quickViewHtml +=
              '<span id="ProductPrice-product-template">' +
              theme.Currency.formatMoney(variants[0].price, theme.moneyFormat) +
              "</span>&nbsp&nbsp";
          }
          if (data.product.product_type != "Eyeglasses") {
            quickViewHtml += '<s id="ComparePrice-product-template">';
            if (variants[0].compare_at_price > variants[0].price) {
              quickViewHtml += theme.Currency.formatMoney(
                variants[0].compare_at_price,
                theme.moneyFormat
              );
            }
            quickViewHtml += "</s>";
          }
          quickViewHtml +=
            '<p class="a_color">' + total_color + " Colors </span>";
          quickViewHtml +=
            '<span class="product-price__sale-label product-price__sale-label-product-template hide">Sale</span>';
          quickViewHtml += "</span></p>";

          quickViewHtml +=
            ' <form action="/cart/add" method="post" enctype="multipart/form-data" class="product-form product-form-product-template" data-section="product-template">';
          quickViewHtml +=
            '<select id="product-select-qv" name="id" style="display: none;">';
          for (i = 0; i < product.variants.length; i++) {
            var _var = product.variants[i];
            var variant_aviable = _var.available;
            c_price = 0;

            if (product_v_qty[i] > product_max_qty) {
              variant_aviable = true;
            } else {
              variant_aviable = false;
            }
            if (_var.compare_at_price > _var.price) {
              c_price = _var.compare_at_price;
            }
            if (c_price != 0) {
              quickViewHtml +=
                '<option value="' +
                _var.id +
                '" data-available="' +
                variant_aviable +
                '" data-qprice="' +
                theme.Currency.formatMoney(_var.price, theme.moneyFormat) +
                '" data-cprice="' +
                theme.Currency.formatMoney(c_price, theme.moneyFormat) +
                '">' +
                _var.title +
                "</option>";
            } else {
              quickViewHtml +=
                '<option value="' +
                _var.id +
                '" data-available="' +
                variant_aviable +
                '" data-qprice="' +
                theme.Currency.formatMoney(_var.price, theme.moneyFormat) +
                '" data-cprice="0">' +
                _var.title +
                "</option>";
            }
          }
          quickViewHtml += "</select>";

          for (i = 0; i < product.options.length; i++) {
            var prd_opt = product.options[i];
            quickViewHtml += '<div class="select_quick';
            if (prd_opt.values.length < 2) {
              quickViewHtml += ' hide">';
            } else {
              quickViewHtml += '">';
            }

            quickViewHtml += "<label>" + prd_opt.name + ":</label>";
            quickViewHtml +=
              '<select id="product-select-qv-opt-' +
              i +
              '" class="product-select-qv ' +
              prd_opt.name.toLowerCase().replace(/ /g, "-") +
              '" >';
            for (j = 0; j < prd_opt.values.length; j++) {
              var _opt = prd_opt.values[j];
              quickViewHtml +=
                '<option value="' + _opt + '">' + _opt + "</option>";
            }
            quickViewHtml += "</select></div>";
          }

          var a = new Array();
          if (
            (a.push("Size"), (a.push("Color"), a.push("Colour")), a.length > 0)
          ) {
            var o = ".png",
              r = !1,
              n = !1,
              s = 0,
              l = window.asset_url.substring(
                0,
                window.asset_url.lastIndexOf("?")
              ),
              d = window.asset_url.substring(
                window.asset_url.lastIndexOf("?"),
                window.asset_url.length
              );
            var e = product;
            for (i = 0; i < e.options.length; i++) {
              var s_class = "";
              if (i == 0) {
                s_class = "swatch_mob_slider owl-carousel owl-theme";
              }
              var c = "";
              if (
                ((c =
                  "object" == typeof e.options[i]
                    ? e.options[i].name
                    : e.options[i]),
                  (r = !1),
                  (n = !1),
                  a.indexOf(c) > -1)
              ) {
                (r = !0), (s = i);
                var u = c.toLowerCase();
                if ((/color|colour/i.test(u) && (n = !0), r)) {
                  var dd = e.variants[0];
                  var ydd = dd.options[i];

                  var h = "",
                    f = ydd;

                  (h +=
                    '<div class="swatch optiondd' +
                    e.options[i].values.length +
                    " " +
                    u +
                    ' clearfix" data-option-index="' +
                    s +
                    '">'),
                    (h +=
                      '<div class="header"><span>' +
                      c +
                      ": </span>" +
                      f +
                      "</div><div class='" +
                      s_class +
                      "'>");
                  var m = new Array();
                  for (j = 0; j < e.variants.length; j++) {
                    var p = e.variants[j];
                    if (!p.featured_image) {
                      continue;
                    }
                    if (product_v_hide[j] == "hide") {
                      console.log(product_v_hide[j]);
                      continue;
                    }
                    var imgsrc = p.featured_image.src;
                    var y = p.options[s],
                      g = y
                        .toLowerCase()
                        .replace(/[^a-z0-9 -]/g, "")
                        .replace(/\s+/g, "-")
                        .replace(/-+/g, "-"),
                      v = "swatch-" + s + "-" + g;
                    var add_class = "ddclass";
                    if (g == v_id) {
                      add_class = "ddtclass";
                    }
                    if (c == "Color") {
                      if (data_avlcolor.indexOf(y) != -1) {
                        m.indexOf(y) < 0 &&
                          ((h +=
                            '<div data-value="' +
                            y +
                            '" id="' +
                            add_class +
                            '" class="swatch-element ' +
                            (n ? "color " : "") +
                            g +
                            (p.available ? " available " : " soldout ") +
                            '">'),
                            n && (h += '<div class="tooltip">' + y + "</div>"),
                            (h +=
                              '<input id="' +
                              v +
                              '" type="radio" name="option-' +
                              s +
                              '" value="' +
                              y +
                              '"' +
                              (0 == j ? " checked " : "") +
                              (p.available ? "" : " ") +
                              "/>"),
                            n
                              ? ((h +=
                                '<label for="' +
                                v +
                                '" class="img"><img src="' +
                                imgsrc +
                                '" />'),
                                (h +=
                                  '<img class="crossed-out" src="' +
                                  l +
                                  'https://cdn.shopify.com/s/files/1/0008/6156/9085/t/20/assets/soldout.png" />'),
                                (h += "</label>"))
                              : ((h += '<label for="' + v + '">' + y),
                                (h +=
                                  '<img class="crossed-out" src="' +
                                  l +
                                  'https://cdn.shopify.com/s/files/1/0008/6156/9085/t/20/assets/soldout.png" />'),
                                (h += "</label>")),
                            (h += "</div>"),
                            m.push(y));
                      }
                    } else {
                      m.indexOf(y) < 0 &&
                        ((h +=
                          '<div data-value="' +
                          y +
                          '" id="' +
                          add_class +
                          '" class="swatch-element ' +
                          (n ? "color " : "") +
                          g +
                          (p.available ? " available " : " soldout ") +
                          '">'),
                          n && (h += '<div class="tooltip">' + y + "</div>"),
                          (h +=
                            '<input id="' +
                            v +
                            '" type="radio" name="option-' +
                            s +
                            '" value="' +
                            y +
                            '"' +
                            (0 == j ? " checked " : "") +
                            (p.available ? "" : " ") +
                            "/>"),
                          n
                            ? ((h +=
                              '<label for="' +
                              v +
                              '" class="img"><img src="' +
                              imgsrc +
                              '" />'),
                              (h +=
                                '<img class="crossed-out" src="' +
                                l +
                                'https://cdn.shopify.com/s/files/1/0008/6156/9085/t/20/assets/soldout.png" />'),
                              (h += "</label>"))
                            : ((h += '<label for="' + v + '">' + y),
                              (h +=
                                '<img class="crossed-out" src="' +
                                l +
                                'https://cdn.shopify.com/s/files/1/0008/6156/9085/t/20/assets/soldout.png" />'),
                              (h += "</label>")),
                          (h += "</div>"),
                          m.push(y));
                    }

                    //  m.indexOf(y) < 0 && (h += '<div data-value="' + y + '" id="'+ add_class +'" class="swatch-element ' + (n ? "color" : "") + g + (p.available ? " available " : " soldout ") + '">', n && (h += '<div class="tooltip">' + y + "</div>"), h += '<input id="' + v + '" type="radio" name="option-' + s + '" value="' + y + '"' + (0 == j ? " checked " : "") + (p.available ? "" : " ") + "/>", n ? (h += '<label for="' + v + '" class="img"><img src="'+ imgsrc +'" />', h += '<img class="crossed-out" src="' + l + 'https://cdn.shopify.com/s/files/1/0008/6156/9085/t/20/assets/soldout.png" />', h += "</label>") : (h += '<label for="' + v + '">' + y, h += '<img class="crossed-out" src="' + l + 'https://cdn.shopify.com/s/files/1/0008/6156/9085/t/20/assets/soldout.png" />', h += "</label>"), h += "</div>", m.push(y))
                  }
                  h += "</div></div>";
                  quickViewHtml += h;
                }
              }
            }
          }
          if (data.product.product_type != "Eyeglasses") {
            if (variants[0].compare_at_price > variants[0].price) {
              quickViewHtml +=
                '<input type="hidden" id="saleitem" name="properties[saleitem]" value="1">';
            } else {
              quickViewHtml +=
                '<input type="hidden" id="saleitem" name="notsaleiteam">';
            }
            quickViewHtml +=
              '<div class="product-form-item product-form_item-submit" data-product-options="" data-vpid="' +
              variants[0].id +
              '">';
            if (product_v_qty[0] > product_max_qty) {
              quickViewHtml +=
                '<button type="submit" name="add" id="AddToCart-product-template" class="btn product-form__cart-submit">';
              quickViewHtml +=
                '<span id="AddToCartText-product-template">Add to cart</span>';
            } else {
              quickViewHtml +=
                '<button type="submit" name="add" id="AddToCart-product-template" class="btn product-form__cart-submit" disabled="disabled">';
              quickViewHtml +=
                '<span id="AddToCartText-product-template">Sold Out</span>';
            }
            quickViewHtml += "</button>";
            quickViewHtml += "</div>";
          } else {
            quickViewHtml +=
              '<div class="sold-store product-form-item product-form_item-submit">';
            quickViewHtml +=
              '<a href="javascript:void(0);" class="AddToCart-product-template btn product-form__cart-submit">Currently Only Sold In Stores</a>';
            quickViewHtml +=
              '<span><a href="/apps/store-locator">Find A Store Nearest You</a></span>';
            quickViewHtml += "</div>";
          }

          quickViewHtml += "</form>";

          quickViewHtml += "</div>";
          quickViewHtml += '<div class="product-detail-row">';
          quickViewHtml +=
            '<a href="' +
            data_url +
            '" class="product-detail__more-details">More details</a>';
          quickViewHtml += "</div>";
          quickViewHtml += "</div></div></div></div></div></div></div></div>";

          $("#myModal .modal-dialog").html(quickViewHtml);

          setTimeout(function () {
            if (data_color != "") {
              $('input[value="' + selected_variant + '"]')
                .prop("checked", true)
                .trigger("change");
            }
          }, 300);

          $('.swatch-element input[type="radio"]').change(function () {
            var ddt = jQuery(this).val();
            if ($(this).closest('.swatch').hasClass('color')) {
              $(this).closest('.swatch').find('.header').html("<span>Color: </span>" + ddt);
              $(this).closest('form').find('select.product-select-qv.color').val(ddt).change();
            }
            if (
              $(this)
                .closest(".swatch")
                .hasClass("size")
            ) {
              $(this)
                .closest(".swatch")
                .find(".header")
                .html("<span>Size: </span>" + ddt);
              $(this)
                .closest("form")
                .find("select.product-select-qv.size")
                .val(ddt)
                .change();
            }
          });

          setTimeout(function () {
            $("#divImage").css("display", "none");
          }, 1000);

          // quickview variant change
          $('.product-select-qv').change(function () {
            var variant_name = $('#product-select-qv-opt-0').val() + ' / ' + $('#product-select-qv-opt-1').val();
            $('#product-select-qv option').filter(function () {
              return $(this).text() == variant_name
            }).prop('selected', true);
            $('#product-select-qv option').trigger('change');
            var c_new_price = $('#product-select-qv option:selected').attr('data-cprice');
            $('#myModal .modal-dialog #ProductPrice-product-template').text($('#product-select-qv option:selected').attr('data-qprice'));
            if (c_new_price != '0') {
              $('#myModal .modal-dialog #ComparePrice-product-template').text($('#product-select-qv option:selected').attr('data-cprice'));
              $('#saleitem').attr("name", "properties[saleitem]");
              $('#saleitem').val(1);
            } else {
              $('#saleitem').attr("name", "notsaleiteam");
              $('#myModal .modal-dialog #ComparePrice-product-template').text("");
            }
            $('#myModal .modal-dialog .product-form_item-submit').attr('data-vpid', $('#product-select-qv').val());
            if ($('#product-select-qv option:selected').text() != variant_name) {
              $('#myModal .modal-dialog .product-form_item-submit .product-form__cart-submit').attr('disabled', 'disabled');
              $('#myModal .modal-dialog #ProductPrice-product-template').css('opacity', '0');
              $('#myModal #AddToCartText-product-template').text("Unavailable");
              $('#myModal .modal-dialog .product-form_item-submit .product-form__cart-submit').attr('disabled', 'disabled');
            } else {
              $('#myModal .modal-dialog .product-form_item-submit .product-form__cart-submit').removeAttr('disabled');
              $('#myModal .modal-dialog #ProductPrice-product-template').css('opacity', '1');
              var variant_aviable = $('#product-select-qv option:selected').attr('data-available');
              if (variant_aviable == 'true') {
                $('#myModal #AddToCartText-product-template').text("Add To Cart");
                $('#myModal .modal-dialog .product-form_item-submit .product-form__cart-submit').removeAttr('disabled');
              } else {
                $('#myModal #AddToCartText-product-template').text("Sold Out");
                $('#myModal .modal-dialog .product-form_item-submit .product-form__cart-submit').attr('disabled', 'disabled');
              }
            }

            $('.quick-slider').empty().removeClass('slick-initialized').removeClass('slick-slider');
            $('.pro_slick-pager').empty().removeClass('slick-initialized').removeClass('slick-slider');
            for (var image in product.images) {
              var fstVar2 = $('#product-select-qv-opt-0').val();
              var prdImgAlt2 = product.images[image].alt;
              if (fstVar2.indexOf(prdImgAlt2) > -1) {
                $(".quick-slider").append(
                  '<div><div class="pro_img"><img class="product_img" src="' +
                  product.images[image].src +
                  '"></div></div>'
                );
              }
              if ($.trim(prdImgAlt2).length > 45) {
                if (
                  prdImgAlt2.indexOf("youtube") > -1 ||
                  prdImgAlt2.indexOf("vimeo") > -1
                ) {
                  $(".quick-slider").append(
                    '<div class="resp-container"><div class="video_wrapper"> <iframe class="resp-iframe" src="' +
                    prdImgAlt2 +
                    '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div></div>'
                  );
                }
              }
            }

            for (var image in product.images) {
              var fstVar3 = $("#product-select-qv-opt-0").val();
              var prdImgAlt3 = product.images[image].alt;
              if (fstVar3.indexOf(prdImgAlt3) > -1) {
                $(".pro_slick-pager").append(
                  '<div><div class="product_thumbnails"><img src="' +
                  product.images[image].src +
                  '" /></div></div>'
                );
              }
              if ($.trim(prdImgAlt3).length > 45) {
                if (
                  prdImgAlt3.indexOf("youtube") > -1 ||
                  prdImgAlt3.indexOf("vimeo") > -1
                ) {
                  $(".pro_slick-pager").append(
                    '<div><div class="product_thumbnails dd-thumbslide-vdo"><img src="' +
                    product.images[image].src +
                    '" /></div></div>'
                  );
                }
              }
            }

            $(".quick-slider").slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              fade: true,
              asNavFor: ".pro_slick-pager"
            });
            $(".pro_slick-pager").slick({
              slidesToShow: 4,
              slidesToScroll: 1,
              asNavFor: ".quick-slider",
              dots: false,
              focusOnSelect: true
            });
          });

          $(".quick-slider").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: ".pro_slick-pager"
          });
          $(".pro_slick-pager").slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            asNavFor: ".quick-slider",
            dots: false,
            focusOnSelect: true
          });
          $(".swatch_mob_slider").owlCarousel({
            nav: true,
            responsive: {
              0: {
                items: 3
              },
              600: {
                items: 4
              },
              1000: {
                items: 4
              }
            }
          });
          $("#ddtclass input:radio").trigger("click");
          if ($(".spr-badge").length > 0) {
            $.getScript(
              window.location.protocol +
              "//productreviews.shopifycdn.com/assets/v4/spr.js"
            );
          }
          if ($(".product-form.product-form-product-template").length > 0) {
            $(".product-form.product-form-product-template").submit(function (
              e
            ) {
              e.preventDefault();
              var data_vpid = parseInt(
                $(this)
                  .find(".product-form_item-submit")
                  .attr("data-vpid")
              );
              if ($("#saleitem").length > 0) {
                var data_property = $("#saleitem").attr("name");
                console.log(data_property);
                if (data_property == "notsaleiteam") {
                  addToCart(data_vpid, 1);
                } else {
                  addToCartattr(data_vpid, 1, data_property);
                }
              } else {
                addToCart(data_vpid, 1);
              }
              $("#myModal .close").click();
            });
          }
        });
      },
      error: function () {
        console.log("error");
      }
    });
  });
  $(".swatch.dd_color .swatch_desktop_slider").slick({
    slidesToShow: 3,
    loop: false,
    infinite: false,
    slidesToScroll: 3,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

  $(document).on(
    "click",
    '.swatch[data-option-index="0"] .swatch-element',
    function () {
      var url = $(this).attr("hidenimg");
      var v_url = $(this).attr("variant-url");
      var v_color = $(this).attr("data-value");
      var v_id = $(this).attr("data_v_id");
      var h_value = $(this).attr("data-v");
      var v_c_price = $(this).attr("datacprice");
      $(this)
        .parents(".product-tile__info")
        .siblings(".grid-view-item__link")
        .attr("href", v_url);
      $(this)
        .parents(".product-tile__info")
        .children(".product-tile__wrap")
        .children(".grid-view-item__title")
        .children("a")
        .attr("href", v_url);
      $(this)
        .parents(".product-tile__info")
        .siblings(".grid-view-item__link")
        .children(".grid-view-item__image-wrapper")
        .children(".product-tile__image-wrap")
        .find(".hiddendd")
        .attr("src", url);
      var vimage = $(this).attr("dataurl");
      var price = $(this).attr("datav-price");
      $(this)
        .parents(".product-tile__info")
        .children(".product-tile__wrap")
        .children(".grid-view-item__types")
        .text(v_color);
      $(this)
        .parents(".product-tile__info")
        .find(".product-tile__quickview")
        .attr("data-first-variant", v_color);
      $(this)
        .parents(".coll_desc_left")
        .siblings(".coll_desc_right")
        .children(".product-tile__wrap")
        .children(".grid-view-item__types")
        .text(v_color);
      $(this)
        .parents(".product-tile__info")
        .children(".mob_col_btn")
        .children("#productform")
        .children(".var_cart")
        .attr("data-variant", v_id);
      //$('#productform .var_cart').attr('data-variant',v_id);
      $(".product-tile__quickview").attr("data-vid", h_value);
      $(this)
        .parents(".product-tile__info")
        .children(".mob_col_btn")
        .children("#productform")
        .children(".var_cart")
        .val(v_id);
      $(this)
        .parents(".product-tile__info")
        .children(".mob_col_btn")
        .children("#productform")
        .children(".var_cart")
        .attr("datacprice", v_c_price);
      $(this)
        .parents(".product-tile__info")
        .find(".product-tile__wrap .price")
        .text(price);
      $(this)
        .parents(".product-tile__info")
        .siblings(".grid-view-item__link")
        .children(".grid-view-item__image-wrapper")
        .children(".product-tile__image-wrap")
        .find(".mainimg")
        .attr("src", vimage);
      if ($(this).hasClass("soldout")) {
        $(".template-article .ajexcart").val("Sold Out");
        $(".template-article .ajexcart").prop("disabled", true);
        $(this)
          .parents(".product-tile__info")
          .children(".mob_col_btn")
          .find("#productform .btn")
          .val("Sold Out");
        $(this)
          .parents(".product-tile__info")
          .children(".mob_col_btn")
          .find("#productform .btn")
          .prop("disabled", true);
      } else {
        $(".template-article .ajexcart").val("Add To Cart");
        $(".template-article .ajexcart").prop("disabled", false);
        $("#productform .btn").val("Add To Cart");
        $("#productform .btn").prop("disabled", false);
      }
    }
  );
  // if ($(window).width() < 767) {
  //   $(".slideshow__slide").each(function() {
  //     var v_url = $(this)
  //       .find(".slideshow__image .desktop_img_new")
  //       .attr("data-src");
  //     $(this)
  //       .find(".slideshow__image .desktop_img_new")
  //       .attr("src", v_url);
  //   });
  //   $(document).on("click", ".mob_col_btn", function(e) {
  //     e.preventDefault();
  //     $.getJSON("/cart.js", function(cart) {
  //       var items = cart.items;
  //       if (cart.item_count > 0) {
  //         if (
  //           items[0].id == 7943202832445 ||
  //           items[0].id == 7943202766909 ||
  //           items[0].id == 7943202799677 ||
  //           items[0].id == 7943202865213
  //         ) {
  //           $(".err_msg").remove();
  //           $(".mob_col_btn").prepend(
  //             '<p class="err_msg">Gift cards must be purchased separately</p>'
  //           );
  //           $(".header-section").prepend(
  //             '<p class="err_msg">Gift cards must be purchased separately</p>'
  //           );
  //           console.log("Gift cards must be purchased separately");
  //           console.log(cart);
  //           return false;
  //         } else {
  //           $("#productform").submit();
  //         }
  //       } else {
  //         $("#productform").submit();
  //       }
  //     });
  //     return true;
  //   });
  // }
  function addToCartnew(variantId, qty) {
    $.ajax({
      url: "/cart/add.js",
      type: "POST",
      data: { quantity: qty, id: variantId },
      success: function (data) {
        document.location.href = "/cart";
      },
      error: function (error) {
        document.location.href = "/cart";
      }
    });
  }
  function addToCartnewattr(variantId, qty, attribute) {
    $.ajax({
      url: "/cart/add.js",
      type: "POST",
      data: { quantity: qty, id: variantId, properties: { saleitem: 1 } },
      success: function (data) {
        document.location.href = "/cart";
      },
      error: function (error) {
        document.location.href = "/cart";
      }
    });
  }
  $(document).on("click", "#productform .addrightvariant", function (e) {
    e.preventDefault();
    var v_id = $(this)
      .siblings(".var_cart")
      .attr("data-variant");
    var v_c_price = $(this)
      .siblings(".var_cart")
      .attr("datacprice");
    var product_pro = "properties[saleitem]";
    if (v_c_price == "true") {
      addToCartnewattr(v_id, 1, product_pro);
    } else {
      addToCartnew(v_id, 1);
    }
  });
}
jQuery(document).ready(function () {
  $(".ment_collection_slider").slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    autoplay: true,
    autoplaySpeed: 4000
  });

  $(".seen_on_part_slider")
    .on({
      beforeChange: function (
        event,
        slick,
        current_slide_index,
        next_slide_index
      ) {
        $(".seen_on_part_slider .slick-active.slick-center").click(function () {
          var myurl = $(this)
            .find(".seen_on_part_img a")
            .attr("href");
          window.location.href = myurl;
        });
      }
    })
    .slick({
      centerMode: true,
      centerPadding: "200px",
      slidesToShow: 3,
      autoplay: false,
      focusOnSelect: true,
      autoplaySpeed: 5000,
      speed: 1000,
      cssEase: "ease-in-out",
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: "100px",
            slidesToShow: 3
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: "100px",
            slidesToShow: 1
          }
        }
      ]
    });
  $(".seen_on_part_slider").on("swipe", function (event, slick, direction) {
    $(".seen_on_part_slider .slick-active.slick-center").click(function () {
      var myurl = $(this)
        .find(".seen_on_part_img a")
        .attr("href");
      window.location.href = myurl;
    });
  });
  jQuery(".seen_on_part_slider").on("afterChange", function (
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    $(".seen_on_part_slider .slick-active.slick-center").click(function () {
      var myurl = $(this)
        .find(".seen_on_part_img a")
        .attr("href");
      window.location.href = myurl;
    });
  });
  if ($(".tab_right_slider .alt_slider").length > 1) {
    $(".tab_right_slider").slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            arrows: false,
            dots: false,
            centerMode: true,
            centerPadding: "30px",
            slidesToShow: 1
          }
        }
      ]
    });
  }

  var legth = $(".productslider > div").length;
  if (legth > 1) {
    $(".productslider").owlCarousel({
      loop: true,
      margin: 10,
      responsiveClass: true,
      onDragged: function (event) {
        $(".productslider").owlCarousel('refresh');
      },
      responsive: {
        0: {
          items: 1,
          loop: false,
          infinite: true,
          margin: 10,
          focusOnSelect: true,
          nav: true
        },
        600: {
          items: 1,
          infinite: true,
          focusOnSelect: true,
          loop: false,
          margin: 10,
          nav: false
        },
        1000: {
          items: 3,
          nav: true,
          loop: true
        }
      }
    });
    //
    $('.owl-next').on('click', function () {
      $(".productslider").owlCarousel('refresh');
    });
    $('.owl-prev').on('click', function () {
      $(".productslider").owlCarousel('refresh');
    });
    setTimeout(function () {
      $('.owl-next').click();
      $('.owl-prev').click();
    }, 100);

  }

  $(document).on("click", ".press-categories__menu", function () {
    $(this)
      .siblings(".press-categories__list")
      .toggle();
    $(this).toggleClass("active");
  });
  $(document).on("click", ".side-nav", function () {
    $(this)
      .siblings(".side-nav__list")
      .toggle();
    $(this).toggleClass("active");
  });
  $(document).on("click", ".blog-detail__nav  .side-nav__menu", function () {
    $(this)
      .siblings(".side-nav__list")
      .toggle();
    $(this).toggleClass("active");
  });
});
$(document).ready(function () {
  $(".popup-youtube, .popup-vimeo, .popup-gmaps").magnificPopup({
    disableOn: 700,
    type: "iframe",
    mainClass: "mfp-fade",
    removalDelay: 160,
    preloader: false,

    fixedContentPos: false
  });

  $(document).on("click", ".ajexcart", function () {
    var variant_id = $(this).attr("data-variant");
    addToCart(variant_id, 1);
  });
  // $(document).on('click', 'a[href^="#"]', function(e) {
  //     var id = $(this).attr('href');
  //     var $id = $(id);
  //     if ($id.length === 0) {
  //         return;
  //     }
  //     e.preventDefault();
  //     var pos = $id.offset().top;
  //     $('body, html').animate({scrollTop: pos});
  // });
  $(function () {
    $(".seen_on_part_slider .slick-slide .seen_on_part_img a").on(
      "click",
      function (e) {
        e.preventDefault();
      }
    );
    $(".seen_on_part_slider .slick-active.slick-center").click(function () {
      var myurl = $(this)
        .find(".seen_on_part_img a")
        .attr("href");
      window.location.href = myurl;
    });
  });
  var tablength = $(".product-detail-tabs-slide__list").length;
  if (tablength == 1) {
    $(".size_list").css("display", "block");
    var shap = $(
      ".product-detail-tabs-slide__list .product-detail-tabs-slide__item:eq(0)"
    ).text();
    if (shap == "Frame Width: Medium") {
      $(".size_list ul li:eq(0)").remove();
    } else if (shap == "Frame Width: Wide") {
      $(".narrow span").text("Wide");
      $(".size_list ul li:eq(1)").remove();
    } else {
      $(".size_list ul li:eq(1)").remove();
    }
  }
  var fitGuideSlider = {
    arrows: false,
    autoplay: false,
    centerMode: true,
    centerPadding: "0",
    dots: true,
    draggable: true,
    easing: "swing",
    infinite: false,
    mobileFirst: true,
    respondTo: "window",
    slide: "div",
    slidesToShow: 1,
    swipe: true,
    useCSS: false,
    useTransform: false
  };
  $(".product-detail-tabs-slider__list").slick(fitGuideSlider);
  $(document).on("click", ".icon--search", function () {
    $(".site_header_hover").toggleClass("active");
  });

  $(document).on("click", ".page-container", function (e) {
    $(".site_header_hover").removeClass("active");
  });
  $(document).on(
    "click",
    ".generic-filter.generic-filter--standard",
    function () {
      $(".generic-filter-dropdown").toggleClass("active");
    }
  );

  if ($(window).width() < 767) {
    $(".slideshow__slide").each(function () {
      var v_url = $(this)
        .find(".slideshow__image .desktop_img_new")
        .attr("data-mob-src");

      $(this)
        .find(".slideshow__image .desktop_img_new")
        .attr("src", v_url);
    });
    $(document).on("click", ".mob_col_btn", function (e) {
      e.preventDefault();
      $.getJSON("/cart.js", function (cart) {
        var items = cart.items;
        if (cart.item_count > 0) {
          if (
            items[0].id == 7943202832445 ||
            items[0].id == 7943202766909 ||
            items[0].id == 7943202799677 ||
            items[0].id == 7943202865213
          ) {
            $(".err_msg").remove();
            $(".mob_col_btn").prepend(
              '<p class="err_msg">Gift cards must be purchased separately</p>'
            );
            $(".header-section").prepend(
              '<p class="err_msg">Gift cards must be purchased separately</p>'
            );
            console.log("Gift cards must be purchased separately");
            console.log(cart);
            return false;
          } else {
            $("#productform").submit();
          }
        } else {
          $("#productform").submit();
        }
      });
      return true;
    });
    $(document).on("click", ".AddToCart-product-template", function (e) {
      e.preventDefault();
      $.getJSON("/cart.js", function (cart) {
        var items = cart.items;
        if (cart.item_count > 0) {
          if (
            items[0].id == 7943202832445 ||
            items[0].id == 7943202766909 ||
            items[0].id == 7943202799677 ||
            items[0].id == 7943202865213
          ) {
            $(".err_msg").remove();
            $(".header-section").prepend(
              '<p class="err_msg">Gift cards must be purchased separately</p>'
            );
            console.log("Gift cards must be purchased separately");
            console.log(cart);
            return false;
          } else {
            $(".product-form").submit();
          }
        } else {
          $(".product-form").submit();
        }
      });
      return true;
    });
    /* $(".product-form.product-form-product-gift-card-template").submit(function(e){
      $.getJSON('/cart.js', function(cart) {
        var items = cart.items;
          if(cart.item_count > 0){
             $('.err_msg').remove();
              $('.header-section').prepend('<p class="err_msg">Gift cards must be purchased separately</p>');
              console.log('Gift cards must be purchased separately');
               console.log(cart)
               return false;
          }else{
             $(".product-form.product-form-product-gift-card-template").submit();
          }
      });
   });*/
  } else {
    document.addEventListener("lazyunveilread", function (event) {
      $(".slideshow__slide").each(function () {
        var v_url = $(this)
          .find(".slideshow__image .desktop_img_new")
          .attr("data-src");

        $(this)
          .find(".slideshow__image .desktop_img_new")
          .attr("src", v_url);
      });
    });
  }
});
$(document).ready(function () {
  if ($(window).width() > 1024) {
    $(".scrollbars").ClassyScroll();
  }
});

$(document).ready(function () {
  $(".round_boxes_images").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    mobileFirst: true,
    useTransform: false
  });
});

$(document).ready(function () {
  $(".pro_gallery").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 749,
        slidesToShow: 1,
        slidesToScroll: 1,
        settings: "unslick"
      }
    ]
  });
});

function addToCartnew(variantId, qty) {
  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: { quantity: qty, id: variantId },
    success: function (data) {
      document.location.href = "/cart";
    },
    error: function (error) {
      document.location.href = "/cart";
    }
  });
}
function addToCartnewattr(variantId, qty, attribute) {
  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: { quantity: qty, id: variantId, properties: { saleitem: 1 } },
    success: function (data) {
      document.location.href = "/cart";
    },
    error: function (error) {
      document.location.href = "/cart";
    }
  });
}
$(document).on("click", "#productform .addrightvariant", function (e) {
  e.preventDefault();
  var v_id = $(this)
    .siblings(".var_cart")
    .attr("data-variant");
  var v_c_price = $(this)
    .siblings(".var_cart")
    .attr("datacprice");

  var product_pro = "properties[saleitem]";
  if (v_c_price == "true") {
    addToCartnewattr(v_id, 1, product_pro);
    console.log(v_c_price);
  } else {
    addToCartnew(v_id, 1);
  }
});
/*Handle base scripts*/
$(document).ready(function () {
  var pathweb = window.location.href;
  pathweb = pathweb.split("=");
  if (pathweb == 'https://raen.com/apps/store-locator') {
    $('.page-container').append('<nav class="breadcrumb" role="navigation" aria-label="breadcrumbs"><a href="/" title="Home">Home</a><span aria-hidden="true" class="arw">&gt;</span><span></span></nav>');
    $('.section-newsletter').remove();
    $('.site-footer').css('border-top', '5px solid #f5ba46');
  }
  if (pathweb[1] == 'manual' || pathweb[1] == 'created-descending' || pathweb[1] == 'price-ascending' || pathweb[1] == 'price-descending') {
    $('.sortby__title #hidethis').css('display', 'none');
  }
  if (pathweb[1] == 'grid') {
    $('.collection-view button').removeClass('change-view--active');
    $('.collection-view button:eq(1)').addClass('change-view--active');
  }
  else if (pathweb[1] == 'list') {
    $('.collection-view button').removeClass('change-view--active');
    $('.collection-view button:eq(2)').addClass('change-view--active');
  }
  else {
    $('.collection-view button').removeClass('change-view--active');
    $('.collection-view button:eq(0)').addClass('change-view--active');
  }
  $('.change-view').click(function () {
    $(this).siblings().removeClass('change-view--active');
    $(this).addClass('change-view--active');
    var url = $(this).attr("data-add");
    if (url == 'normal') {
      $('.dd-filter-data').removeClass('collection_two');
      $('.dd-filter-data').removeClass('collection_list');
      $('.dd-filter-data-new').removeClass('collection_two');
      $('.dd-filter-data-new').removeClass('collection_list');
      $('.swatch.dd_color .swatch_desktop_slider').slick('unslick');
      $('.swatch.dd_color .swatch_desktop_slider').slick({
        slidesToShow: 3,
        loop: false,
        infinite: false,
        slidesToScroll: 3,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
            }
          }
        ]
      });
    } else if (url == 'grid') {
      $('.dd-filter-data').removeClass('collection_list')
      $('.dd-filter-data').addClass('collection_two');
      $('.dd-filter-data-new').removeClass('collection_list')
      $('.dd-filter-data-new').addClass('collection_two');
      $('.swatch.dd_color .swatch_desktop_slider').slick('unslick');
      $('.swatch.dd_color .swatch_desktop_slider').slick({
        slidesToShow: 3,
        loop: false,
        infinite: false,
        slidesToScroll: 3,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
            }
          }
        ]
      });
    } else if (url == 'list') {
      $('.dd-filter-data').removeClass('collection_two');
      $('.dd-filter-data').addClass('collection_list');
      $('.dd-filter-data-new').removeClass('collection_two');
      $('.dd-filter-data-new').addClass('collection_list');
      $('.swatch.dd_color .swatch_desktop_slider').slick('unslick');
      $('.swatch.dd_color .swatch_desktop_slider').slick({
        slidesToShow: 3,
        loop: false,
        slidesToScroll: 3,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
            }
          }
        ]
      });
    }

  });
});
/*Account page*/
function showRecoverPasswordForm() {
  $('#RecoverPasswordForm').css('display', 'block');
  $('#customer_login').css('display', 'none');
}

function hideRecoverPasswordForm() {
  $('#RecoverPasswordForm').css('display', 'none');
  $('#customer_login').css('display', 'block');
}

if ($('.resetSuccess').length > 0) {
  showRecoverPasswordForm();
  $('.resetNote').addClass('hide');
}
else {
  hideRecoverPasswordForm();
  $('.resetNote').removeClass('hide');
}
